import moment from 'moment'

function emptyDriverPostSettings() {
    return {
        result: [],
        mileage_result: [],
        pdistance: 0,
        ptime: 0,
        porder: 0,
        timesettings: {},
    };
}

function getDriverPostSettings(settingsProduction) {
    if (
        settingsProduction
        && settingsProduction.driver
        && settingsProduction.driver.s
    ) {
        return settingsProduction.driver.s;
    }
    return emptyDriverPostSettings();
}

function getProductionPostSettings(settingsProduction, postCode) {
    if (
        !settingsProduction
        || !postCode
        || !(postCode in settingsProduction)
        || !settingsProduction[postCode]
        || !settingsProduction[postCode].s
    ) {
        return null;
    }
    return settingsProduction[postCode].s;
}

export function eventChangeIntervalSmena(start, end, r) {
    if (!r) r = {};
    if (!r.calc) r.calc = {};
    if (!r.calc.calculation) r.calc.calculation={};

    if (r && r.calc &&r.calc.calculation) {
        let calc = r.calc.calculation;
        if (moment(start, "H:mm").isValid()) {
            calc.timebeg = start + ":00";
        }
        if (moment(end, "H:mm").isValid()) {
            calc.timeend = end + ":00";
        }
    }


}

export function eventChangeSmena(smena, r) {
    if (!r) r = {};
    if (!r.calc) r.calc = {};
    if (!r.calc.calculation) r.calc.calculation={};
    if (r && r.calc &&r.calc.calculation) r.calc.calculation.smena = smena;
}

export function initDelayedFromCrm(r) {
        let calc = r.calc
        let dparams =r.dparams
        let delayed =r.delayed
        calc.delayed.posts = [];
        let  _mappingPosts = {"pizza":"pizzamaker", "drivers":"driver", "sushi":"suhi", "noncash":"noncash", "operator":"Call-centr", "administrator":"administrator", "hot":"hot"};
        let settingsProduction = r.settings.production
        for (var k in dparams) {
            var p = dparams[k];
            if (k  in _mappingPosts && _mappingPosts[k] in settingsProduction) {

                var s = settingsProduction[_mappingPosts[k]];

                var post = {
                    post_code : s.code,
                    showname : s.name,
                    params : p,
                    values : [],
                    rows : [],
                    settings : s.l, //fixme
                    count_workers : 1,
                    count_workers_correctly : 1,  //fixme
                    load : 0,
                    kload : 0,
                    korf : 0, //fixme
                };

                var d = delayed[k];

                var h;
                for (h=calc.delayed.minh; h<=calc.delayed.maxh; h++) {
                    var row = {
                        load : 0,
                        count_workers : 1,
                        count_workers_correctly : 1,  //fixme
                        values : [],
                        kload : 0,
                        korf : 0,
                        orders : [],
                    }
                    if (h in d) {
                        if ("n" in d[h]) row.count_workers = parseInt(d[h].n);
                        if (isNaN(row.count_workers)) row.count_workers = 0;

                        if ("t" in d[h]) row.load = parseInt(d[h].t);
                        if (isNaN(row.load)) row.load = 0;

                        post.load += row.load;


                        for (var i in post.params) {
                            var p = post.params[k];
                            var v = parseFloat(d[h].d[i]);
                            if (isNaN(v)) v = 0;
                            row.values.push(v);
                            row.orders.push(d[h].o[i]);
                        }
                    }


                    post.rows.push(row);
                }

                calc.delayed.posts.push(post);
            }
        }
        r = recalcDelayed(r)
        return r
    }

export function recalcDelayed(r) {
        let calc =r.calc
        if (!("sum" in calc.delayed)) {
            calc.delayed.sum = {};
        }
        if (!("onlyData" in calc.delayed)) {
            if (localStorage.getItem("monitorOnlyData")==1) {
                calc.delayed.onlyData = true;
            } else {
                calc.delayed.onlyData = false;
            }
        }

        calc.delayed.values=[];
        for (var i=0; i<3; i++) calc.delayed.values.push(0);

        calc.delayed.posts.forEach(function(p){
            var numr = 0;

            //рассчет количества людей + с учетом коэффициента
            for (var h=calc.delayed.minh; h<=calc.delayed.maxh; h++) {
                if (p.post_code=="suhi" || p.post_code=="pizzamaker" || p.post_code=="administrator") {
                    var start = h==calc.delayed.minh ? "00:00" : ((h<10) ? "0" : "") + (h) + ":00";
                    var finish = h==calc.delayed.maxh ? "23:59" : ((h<9) ? "0" : "") + (h+1) + ":00";
                    var n = 0, n_correcly = 0;

                    if (calc.production && calc.production.workers) {
                        calc.production.workers.forEach(function(w) {
                            if (w.post_code==p.post_code) {
                                var inter = w.intervals.find(function(i){
                                    var s = i.start.format("HH:mm"), f = i.finish.format("HH:mm");
                                    if (s<f) {
                                        return (finish>s && finish<f) || (start>s && start<f)
                                    }
                                    return false;
                                })
                                if (inter) {
                                    n_correcly += w.s_koutput
                                    n++;
                                }
                            }
                        })
                    }

                    p.rows[numr].count_workers = n;
                    p.rows[numr].count_workers_correctly = n_correcly;
                } else {
                    p.rows[numr].count_workers_correctly = p.rows[numr].count_workers;
                }

                numr++;
            }

            p.norm = p.settings.norm;
            p.norm2 = p.settings.norm2;
            p.load = 0;
            p.count_workers = 0;
            p.values = [];
            p.count_workers_correctly=0;
            p.korf = 0;
            for (var pi in p.params) p.values.push(0);
            var numr = 0;

            //суммируем для должности
            for (var h=calc.delayed.minh; h<=calc.delayed.maxh; h++) {
                //коэффициент нагрузки для строки
                p.rows[numr].kload = 0;
                p.rows[numr].korf = 0;

                if (!(numr in calc.delayed.sum)) {
                    calc.delayed.sum[numr]=0;
                }


                if (p.rows[numr].count_workers_correctly>0)
                    p.rows[numr].kload = p.rows[numr].load / p.rows[numr].count_workers_correctly;

                p.load += p.rows[numr].load;

                //количество  сотрудников - MAX
                p.count_workers += p.rows[numr].count_workers;

                //количество  сотрудников с учетом коэффициентра - MAX
                p.count_workers_correctly += p.rows[numr].count_workers_correctly;

                //количество опозданий + КОРФ для строки
                p.rows[numr].values.forEach(function(v, i){
                    p.values[i]+=v;
                    calc.delayed.sum[numr]+=v;
                    p.rows[numr].korf += v * p.settings[i];
                    p.korf +=  v * p.settings[i];
                    calc.delayed.values[i]+=v;
                })
                var k = p.post_code=="suhi"  || p.post_code=="hot" ? 1000 : 1;
                p.rows[numr].korf = p.rows[numr].kload / k / ( 1 + p.rows[numr].korf );

                numr++;
            }

            //коэффициент нагрузки для должности
            if (p.count_workers_correctly>0)
                p.kload = p.load /  p.count_workers_correctly;
            var k = p.post_code=="suhi"  ? 1000 : 1;
            p.korf = p.kload / k / (1+p.korf);
       });

      return r;
    }

function emptyTotalDrivers(workers, totalSettings) {
    if (!workers) workers = [];

    return {
        worktime : 0,
        orders : 0,
        distance : 0,
        duration : 0,
        plan_duration : 0,
        routes : 0,
        price_time: 0,
        price_orders: 0,
        price_distance: 0,
        price_departure: 0,
        arr_result: 0,
        arr_departure : 0,
        sum_distance : 0,
        sum_departure : 0,
        sum_short_shift : 0,
        bonus_id :  0,
        fine_id :  0,
        author_bonus :  0,
        author_fine :  0,
        sum_duration : 0,
        sum_orders : 0,
        sum_bonus : 0,
        sum_penalty : 0,
        sum : 0,
        sum_round : 0,
        workers : workers,
        rounding_zp : totalSettings.rounding_zp,
        doc_problem: 0,
        fired: 0,
        surcharge_percent : 0,
        surcharge_fix : 0,
        crm_sum : 0,
    }
}

function emptyDriver(calc=null) {
    var w =  {
        minus : 0,
        worker_id : 0,
        worktime : 0,
        orders :  0,
        distance :  0,
        departure :  0,
        duration :  0,
        plan_duration :  0,
        routes :  0,
        sum_distance :  0,
        sum_duration :  0,
        sum_departure :  0,
        sum_short_shift :  0,
        bonus_id :  0,
        fine_id :  0,
        author_bonus :  0,
        author_fine :  0,
        sum_orders :  0,
        sum_bonus : 0,
        sum_penalty :  0,
        sum :  0,
        sum_round : 0,
        sum_calc : 0,
        sum_min : 0,
        percent :  0,
        bonuses : [],
        fines : [],

        doc_problem: 0,
        fired: 0,

        bonus_amount : 0,
        bonus_amount_calc : 0,
        personal_amount : 0,
        personal_amount_calc :0,
        personal : 0,

        min_salary_hour : 0,

        showname : '', //надо чистить

        sum_surcharge : 0,

        intervals : [{start:moment("05:00", "HH:mm"), finish:moment("16:00", "HH:mm")}],
        personal_history : [],
    };

    if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
        w.intervals[0].start = moment(calc.calculation.timebeg, "HH:mm:ss");
    }
    if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
        w.intervals[0].finish = moment(calc.calculation.timeend, "HH:mm:ss");
    }

    return w;
}

 function driverFromCRM (d, worker, calc=null) {
    var w = worker;
    if (!w) {
        w = emptyDriver(calc);
        var start = d.stat.start.match(/\s\d\d:\d\d/)[0].trim();
        var end = d.stat.end.match(/\s\d\d:\d\d/)[0].trim();
        if (end<"04:00") end = "23:59";
        w.intervals =  [{start:moment(start, "HH:mm"), finish:moment(end, "HH:mm")}];
        w.worker_id = d.id;
        w.showname = d.name;
        w.doc_problem = d.doc_problem;
        w.fired = d.fired;
        w.bonuses = d.bonuses;
        w.fines = d.fines;
        w.bonus_amount = d.bonus_amount;
        w.bonus_amount_calc = d.bonus_amount;
        w.personal_amount = d.personal_amount;
        w.personal_amount_calc = d.personal_amount;
    }

    w.minus = d.stat.minus;
    w.distance = d.stat.distance/1000;
    w.orders =  d.stat.orders;
    w.orders_sum = d.stat.orders_sum;
    w.departure =  d.stat.departure;
    w.routes = d.stat.routes;
    w.duration = d.stat.duration/60/60;
    w.plan_duration =  d.stat.plan_duration/60/60;
    return w;
}

export function recalcTableDrivers(result, smena) {
	if (!smena) smena = 1;
    var k = "driver";

    let surcharges = result.surcharges
    let calc = result.calc
	let totalSettings = result.total_settings
    let settingsProduction = result.settings.production
    let drivers = result.drivers
    let allDrivers = result.allDrivers


    if (k in surcharges && Array.isArray(surcharges[k])) {
        surcharges[k].forEach(function(s, i){
            if ("fix" in surcharges[k][i]) {
                var s = parseFloat(surcharges[k][i].fix);
                surcharges[k][i].fix = s;
            }
            if ("percent" in surcharges[k][i]) {
                var s = parseFloat(surcharges[k][i].percent);
                surcharges[k][i].percent = s;
            }

        })
         calc.drivers.surcharges = surcharges[k];
    }

    var post = calc.drivers;
    var percent_arr = [];
    post.worktime = 0;
    post.orders  = 0;
    post.distance = 0;
    post.plan_duration = 0;
    post.duration = 0;
    post.departure = 0;
    post.routes =0;
    post.sum_departure =0;
    post.sum_short_shift =0;
    post.bonus_id = 0;
    post.fine_id = 0;
    post.author_bonus =  0;
    post.author_fine =  0;
    post.sum_distance =0;
    post.sum_duration = 0;
    post.sum_orders = 0;
    post.sum_bonus = 0;
    post.sum_penalty = 0;
    post.sum = 0;
    post.sum_round = 0;
    post.sum_paid = 0;
    post.crm_sum = 0;

    var driverPostSettings = getDriverPostSettings(settingsProduction);

    if (!post.arr_result) {
        post.arr_result = driverPostSettings.result || [];
    }

    if (!post.arr_departure) {
        post.arr_departure = driverPostSettings.mileage_result || [];
    }

    if (!Array.isArray(post.arr_departure)) {
        post.arr_departure = [];
    }

    post.arr_departure.sort(function(s, s1) {
        var m = parseFloat(s.mileage);
        if (isNaN(m)) m = 0;
        return -m;
    })


    var settings = driverPostSettings;

    var depHandMode = false;
    if ("deposit_handmode" in settings) {
        depHandMode = parseFloat(settings.deposit_handmode)==1 ? true : false;
    }
    var depPayment = 0;
    if ("shift_payment" in settings) {
        depPayment = parseFloat(settings.shift_payment);
        if (isNaN(depPayment)) depPayment = 0;
    }
    var depCount = 0;
    if ("shift_count" in settings) {
        depCount = parseFloat(settings.shift_count);
        if (isNaN(depCount)) depCount = 0;
    }
    var depMinSalary = 0;
    if ("dep_min_salary" in settings) {
        depMinSalary = parseFloat(settings.dep_min_salary);
        if (isNaN(depMinSalary)) depMinSalary = 0;
    }
    var depType = "rub";
    if ("shift_payment_type" in settings) {
        depType = settings.shift_payment_type;
    }

    var s = parseFloat(driverPostSettings.pdistance);
    if (!isNaN(s)) {
        post.price_distance = s;
    }
    var s = parseFloat(driverPostSettings.ptime);
    if (!isNaN(s)) {
        post.price_time = s;
    }
    var s = parseFloat(driverPostSettings.porder);
    if (!isNaN(s)) {
       post.price_orders = s;
    }

    if (smena && "timesettings" in driverPostSettings && typeof driverPostSettings.timesettings  === "object"  && Object.keys(driverPostSettings.timesettings).length>0 && smena in driverPostSettings.timesettings) {
        var smenaConfig = driverPostSettings.timesettings[smena];
        if (typeof smenaConfig === "object") {
            if ("pdistance" in smenaConfig) {
                var s = parseFloat(smenaConfig.pdistance);
                if (!isNaN(s)) {
                    post.price_distance = s;
                }
            }
            if ("porder" in smenaConfig) {
                var s = parseFloat(smenaConfig.porder);
                if (!isNaN(s)) {
                    post.price_orders = s;
                }
            }
            if ("ptime" in smenaConfig) {
                var s = parseFloat(smenaConfig.ptime);
                if (!isNaN(s)) {
                    post.price_time = s;
                }
            }
        }
    }
    calc.drivers.posts.forEach(function(post){
        var p = settingsProduction[post.post_code];
        if (!p || !p.s) {
            return;
        }

        if(!post.arr_result){
            post.arr_result = p.s.result;
        }

        if(!post.arr_departure){
            post.arr_departure = p.s.mileage_result;
        }
        if(!post.arr_departure){
            post.arr_departure=[];
        }

        post.arr_departure = post.arr_departure.sort(function(s, s1) {
            var m = parseFloat(s.mileage);
            if (isNaN(m)) m = 0;
            var m1 = parseFloat(s1.mileage);
            if (isNaN(m1)) m1 = 0;
            if (m1<m) return 1;
            return -1;
        })

        var s = parseFloat(p.s.pdistance);
        if (!isNaN(s)) {
            post.price_distance = s;
        }
        var s = parseFloat(p.s.ptime);
        if (!isNaN(s)) {
            post.price_time = s;
        }
        var s = parseFloat(p.s.porder);
        if (!isNaN(s)) {
            post.price_orders = s;
        }

        if (smena && "timesettings" in p.s && typeof p.s.timesettings == "object" && Object.keys(p.s.timesettings).length>0 && smena in p.s.timesettings) {
            var smenaConfig = p.s.timesettings[smena];
            if (typeof smenaConfig == "object") {
                if ("pdistance" in smenaConfig) {
                    var s = parseFloat(smenaConfig.pdistance);
                    if (!isNaN(s)) {
                        post.price_distance = s;
                    }
                }
                if ("porder" in smenaConfig) {
                    var s = parseFloat(smenaConfig.porder);
                    if (!isNaN(s)) {
                        post.price_orders = s;
                    }
                }
                if ("ptime" in smenaConfig) {
                    var s = parseFloat(smenaConfig.ptime);
                    if (!isNaN(s)) {
                        post.price_time = s;
                    }
                }
            }
        }
    })

    //за один проход все считаем
    calc.drivers.workers.forEach(function(w, k){
        var post2 = findPostDriver(w.post_code, calc);
        console.log(post2);
        if (!post2) post2 = post;

        var settings;
        var postSettings = getProductionPostSettings(settingsProduction, post2.post_code);
        if (postSettings !== null) {
            settings = postSettings;
        } else {
            settings = getDriverPostSettings(settingsProduction);
        }

        var depHandMode = false;
        if ("deposit_handmode" in settings) {
            depHandMode = parseFloat(settings.deposit_handmode)==1 ? true : false;
        }
        var depPayment = 0;
        if ("shift_payment" in settings) {
            depPayment = parseFloat(settings.shift_payment);
            if (isNaN(depPayment)) depPayment = 0;
        }
        var depCount = 0;
        if ("shift_count" in settings) {
            depCount = parseFloat(settings.shift_count);
            if (isNaN(depCount)) depCount = 0;
        }
        var depMinSalary = 0;
        if ("dep_min_salary" in settings) {
            depMinSalary = parseFloat(settings.dep_min_salary);
            if (isNaN(depMinSalary)) depMinSalary = 0;
        }
        var depType = "rub";
        if ("shift_payment_type" in settings) {
            depType = settings.shift_payment_type;
        }

        w.bonus_amount_calc = w.bonus_amount;
        w.sum_surcharge = 0;
        post.crm_sum  += w.orders_sum;
        w.route_type = "car";

        if (post2.route_type) {
            w.route_type = post2.route_type;
        }

        //сначала для каждого
        w.worktime = 0;
        w.percent = 0;
        percent_arr = [];

        w.intervals.forEach(function(interval){
            if (typeof interval.start=="string") interval.start = moment(interval.start)
            if (typeof interval.finish=="string") interval.finish = moment(interval.finish)
            var diff = interval.finish.diff(interval.start);
            if (diff<0) {
                diff += 60 * 60 * 1000 * 24;
            }
            if (diff>0) w.worktime += diff;
        })

        w.worktime = w.worktime / 1000 / 60 / 60;

        w.percent = 0; w.min_salary_hour = 0; w.sum_min = 0;
        var min_second = false;
        if (!post2.arr_result) post2.arr_result=[];
        post2.arr_result.forEach(function(result){
            var arr_time = result.timework.split(":");
            var count_second = 0;
            count_second = Number(arr_time[0]*60*60) + Number(arr_time[1]*60);
            if(w.worktime*60*60 <= count_second) {
                if (!min_second || min_second>=count_second) {
                    var pp = parseFloat(result.percent);
                    if (!isNaN(pp)) {
                        w.percent = pp;
                        min_second = count_second;
                    }

                    var minSalary = parseFloat(result.min_salary);


                    if (!isNaN(minSalary) && minSalary) {
                        w.min_salary_hour = minSalary;
                    }
                }
                percent_arr.push(result.percent);
            }
        });
        if (w.worktime<=1) w.percent = 0;
        if (w.min_salary_hour) {
            w.sum_min = w.min_salary_hour * w.worktime;
        }

        //считаем сумму премий за сегодня
        w.sum_bonus = 0;
        w.bonuses.forEach(function(b) {
            w.sum_bonus+=b.amount;
            //t.toPersonalWorker(w.worker_id, b.amount);
        });

        //считаем сумму штрафов за сегодня
        w.sum_penalty = 0;
        w.fines.forEach(function(b) {
            w.sum_penalty+=b.amount;
            //t.toPersonalWorker(w.worker_id, -b.amount);
        });


        w.sum_distance = w.distance * post2.price_distance;
        w.sum_duration = w.worktime * post2.price_time * 60;
        w.sum_orders = w.orders * post2.price_orders;


        if (!(typeof post2.price_departure  === 'number') || isNaN(post2.price_departure))  {
            post2.price_departure = 0;
        }

        if (typeof w.departure  === 'number') w.departure = Math.round(w.departure);
        else w.departure = 0;

        w.sum_departure = 0;
        if (w.departure>0) {
            var price_departure = post2.price_departure;
            var found = false, i=0;
            while (i<post2.arr_departure.length && !found) {
                var pd = parseFloat(post2.arr_departure[i].mileage);
                var price = parseFloat(post2.arr_departure[i].percent);
                if (!isNaN(price) && !isNaN(pd) && w.departure/2/1000>pd) {
                    price_departure = price;
                    found = true;
                }
                i++;
            }
            if (post2.s_typepdepature=="percent") {
                w.sum_departure = (w.sum_distance + w.sum_duration + w.sum_orders) / 100 * price_departure;
            } else  {
                w.sum_departure = price_departure;
            }
        }


        if (post2.s_typetimework=="fix") {
            w.sum_short_shift = w.percent;
        } else {
            w.sum_short_shift = (w.sum_distance + w.sum_duration + w.sum_orders)*w.percent/100;
        }

        w.sum_calc = w.sum_distance + w.sum_duration + w.sum_orders;
        w.sum = w.sum_calc;  w.sum_paid  = w.sum_calc;

        if ("minus" in w) {
            w.sum = w.sum - w.minus;
        } else {
            w.minus = 0;
        }
        if ("minus" in w) {
            w.sum_paid = w.sum_paid - w.minus;
        }

        if (w.sum_min && w.sum_min>w.sum) {
            w.sum = w.sum_min;
            w.sum_paid = w.sum_min;
        }
        var surcharge_percent = 0, surcharge_fix = 0;
        if ("surcharges" in post2 && Array.isArray(post2.surcharges) && post2.surcharges.length>0) {
            post2.surcharges.forEach(function(s){
                var added=false;

                if ("workers_exclude" in s && Array.isArray(s.workers_exclude)) {
                    if(s.workers_exclude.indexOf(w.worker_id)>=0) {
                        return ;
                    }

                    var tb = s["timebeg"];
                    var te = s["timeend"];
                    tb = "0 " + tb;
                    if (te<"10") te = "1 " + te;
                    else te = "0 " + te;

                    var sf =0; sp = 0;
                    w.intervals.forEach(function(i) {
                        if (added) return;

                        var wtb = i.start.format("HH:mm").toString();
                        var wte = i.finish.format("HH:mm").toString();
                        wtb = "0 " + wtb;
                        if (wte<"10") wte = "1 " + wte;
                        else wte = "0 " + wte;

                        if ((wtb==tb && wte==te) || (wtb>te && wtb<te) || (wte>tb && wte<te)) {
                            surcharge_percent += s.percent;
                            surcharge_fix += s.fix;
                            added = true;
                        }
                    })

                }
            })

        }

        w.sum_surcharge += w.sum / 100 * surcharge_percent;
        w.sum_surcharge += surcharge_fix;
        w.sum_deposit = 0;
        w.sum = w.sum + w.sum_surcharge + w.sum_bonus - w.sum_penalty + w.sum_departure + w.sum_short_shift;

        var driver = null
        if (w.worker_id in drivers) driver =drivers[w.worker_id]
      //  var driver = drivers.find(function(d) {return d.id==w.worker_id});
        if (!driver) {
    //        driver = allDrivers.find(function(d) {return d.id==w.worker_id});
	        if (w.worker_id in allDrivers) driver =allDrivers[w.worker_id]
        }

        if (driver) {
            if (!depHandMode && driver.deposit<driver.deposit_norm) {
                var smenas = parseInt(driver.smenas);
                if (isNaN(smenas)) smenas = 0;

                if (depCount==0 || smenas>depCount) {
                    if (depMinSalary==0 || w.sum>depMinSalary) {
                        if (depType == "rub") {
                            w.sum_deposit = depPayment;
                        } else {
                            w.sum_deposit = Math.round(w.sum / 100 * depPayment);
                        }
                    }
                }
            }

        }

        if (driver && driver.deposit_norm-driver.deposit<w.sum_deposit) {
            w.sum_deposit = driver.deposit_norm-driver.deposit;
        }

        if (w.sum_deposit<0) {
            w.sum_deposit = 0;
        }

        w.personal = 0;
        w.personal_history.forEach((p)=>{
            w.personal += p.type=="+" ?  -p.amount : p.amount;
        });
        w.sum_paid = w.sum_paid + w.sum_surcharge + w.sum_departure + w.sum_short_shift;
        w.sum_paid += (w.sum_bonus - w.sum_penalty);
        w.sum_paid += w.personal;

        w.sum_round = Math.round(w.sum/totalSettings.rounding_zp)*totalSettings.rounding_zp;
        w.sum_paid = w.sum_paid - w.sum_deposit
        w.sum_paid = Math.round(w.sum_paid/totalSettings.rounding_zp)*totalSettings.rounding_zp;

        if (w.worker_id==1444) {
            w.sum = 0;
            w.sum_round = 0;
            w.sum_paid = 0 ;
            w.sum_duration = 0;
            w.sum_distance = 0;
            w.sum_departure = 0;
            w.sum_orders = 0;
            w.sum_bonus = 0;
        }

        if ("s_personal_amount" in post2 && post2.s_personal_amount && !w.changedPersonal) {
            toPersonalDriver(w.worker_id, w.sum_paid, result);
            w.personal -= w.sum_paid;
            w.sum_paid = 0;
        }

        //суммируем по всем водителям
        post.worktime += w.worktime;
        post.orders += w.orders;
        post.distance += w.distance;
        post.plan_duration += w.plan_duration;
        post.duration += w.duration;
        post.routes += w.routes;
        post.sum_distance += w.sum_distance;
        post.sum_departure += w.sum_departure;

        post.sum_short_shift += w.sum_short_shift;
        post.sum_duration += w.sum_duration;
        post.sum_orders += w.sum_orders;
        post.sum_bonus += w.sum_bonus;
        post.sum_penalty += w.sum_penalty;
        post.sum += w.sum;
        post.sum_round += w.sum_round;
        post.sum_paid += w.sum_paid;

    });

    calc.drivers.crm_sum = 0;
    calc.drivers.workers.forEach(function(w){
        var driver = null
        if (w.worker_id in drivers) driver =drivers[w.worker_id]
        if (driver) {
            driver.deposit -= w.sum_deposit;
        }
        if ("orders_sum" in w && typeof w.orders_sum==='number') {
            calc.drivers.crm_sum += w.orders_sum;
        }
    })

	return result;
}

    //зачисление на личный счет
function toPersonalDriver(workerID, amount, r) {
    var w = r.calc.drivers.workers.find(function(w) {
        return w.worker_id == workerID;
    })
    w.personal_amount_calc += amount;
}


function toPersonalProduction(workerID, amount, prodWorkers) {
    for (var i in prodWorkers) {
        var w = prodWorkers[i];
        if (w.id==workerID) {
            w.personal_amount_calc += amount;
        }
    }
}


//обновляем данные из CRM
export function recalcTotalDrivers(result, isNew, newFilial) {
	let calc = result.calc
	let drivers = result.drivers
	let totalSettings = result.total_settings
	let surcharges = result.surcharges
    let settingsProduction = result.settings.production
    let settingsPostMapping = {'price_time':'ptime', 'price_distance':'pdistance', 'price_orders':"porder", 'price_departure':'pdeparture', 'arr_result':'result', 's_bonus_amount':'bonus_amount', 's_personal_amount':'personal_amount',
    's_typepdepature': "typepdepature", "s_typetimework" : "typetimework", "arr_departure":"mileage_result"}

    var workers = calc.drivers.workers;
    if (newFilial) {
        workers = [];
    }

    calc.drivers = emptyTotalDrivers(workers, totalSettings);

    if (drivers) {
    	for (var k in drivers) {
    		var d = drivers[k]
            var worker = calc.drivers.workers.find(function(w) {
                return w.worker_id == d.id;
            })


            if (!worker) {
                calc.drivers.workers.push(driverFromCRM(d, null, calc));
                worker = calc.drivers.workers[calc.drivers.workers.length-1];
            } else {
                if ("sum_deposit" in worker && worker.sum_deposit>0) {
                    d.deposit = d.deposit-worker.sum_deposit;
                }
                driverFromCRM(d, worker, calc);
            }

            if (worker && isNew) {
                for (var ii in worker.intervals) {
                    worker.intervals[ii].finish =  moment(new Date());
                }
            }
        }
    }

    calc.drivers = emptyTotalDrivers(calc.drivers.workers, totalSettings);

    var k = "driver";

    if (k in surcharges && Array.isArray(surcharges[k])) {
        surcharges[k].forEach(function(s, i){
            if ("fix" in surcharges[k][i]) {
                var s = parseFloat(surcharges[k][i].fix);
                surcharges[k][i].fix = s;
            }
            if ("percent" in surcharges[k][i]) {
                var s = parseFloat(surcharges[k][i].percent);
                surcharges[k][i].percent = s;
            }

        })
         calc.drivers.surcharges = surcharges[k];
    }


    //переносим настройки (driver может отсутствовать в settings.production)
    var s = getDriverPostSettings(settingsProduction);

    for (var n2 in settingsPostMapping) {
    	let n1 = settingsPostMapping[n2];
        if (n2=="s_typepdepature") calc.drivers[n2] =  "fix";
        else if (n2=="s_typetimework") calc.drivers[n2] = "percent";
        else  calc.drivers[n2] = 0;
        if (n1 in s) {
            var v = parseFloat(s[n1]);
            if(n1 == 'result' || n1=="typepdepature" || n1=="typetimework"){
                v = s[n1];
            }
            if (!isNaN(v)) {
                calc.drivers[n2] = v;
            }
        }
    };

    recalcPostsDrivers(result)
 	result = recalcTableDrivers(result)
 	return result
}

function  emptyWorkerProduction(smena=1, calc=null, noDefaultIntervals=false) {
    var w =  {
        post_code : '',
        worker_id : 0,
        select_id : '',
        bonus_id : 0,
        fine_id : 0,
        author_bonus :  0,
        author_fine :  0,
        category_id : 0,
        category_number : 0,

        s_salary :  0,
        s_kbonus : 0,
        s_kpenaly : 0,
        s_koutput :  0,

        reason_surcharge_id : null,

        worktime : 0,
        worktime_correctly : 0,
        worktime_correctly_penalty : 0,
        normday :  0,
        count_products : 0,

        personal : 0,
        sum_bonus : 0,
        sum_penalty : 0,
        sum_bonus_calc : 0,
        sum_penalty_calc : 0,
        sum_salary : 0,
        sum_compens : 0,
        sum  : 0,
        sum_round : 0,
        sum_paid : 0,
        sum_prepay : 0,

        bonuses : [],
        fines : [],

        doc_problem: 0,
        fired: false,
        recommened_category : 0,

        intervals : noDefaultIntervals ? [] : [{start:moment("05:00", "HH:mm"), finish:moment("16:00", "HH:mm")}],

        showname : '', //надо будет удалить
        showpost : '',
        position : 0,

        sum_surcharge : 0,

        personal_history : []
    }
    if (!noDefaultIntervals && calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
        w.intervals[0].start = moment(calc.calculation.timebeg, "HH:mm:ss");
    }
    if (!noDefaultIntervals && calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
        w.intervals[0].finish = moment(calc.calculation.timeend, "HH:mm:ss");
    }


    if (smena==3) {
        w.intervals = [];
    }
    return w;
}

function  _initCategorySettingProduction(w, categorySetting) {
	let  _settingsWorkerMapping = {
        s_salary :  "salary",
        s_kbonus : "k_bonus",
        s_kpenaly : "k_penalty",
        s_koutput :  "k_output",
        s_bpercent : "bonus_percent"

    };
    if (!categorySetting || !categorySetting.s) {
        return;
    }
    var s = categorySetting.s;
    for (var n2 in _settingsWorkerMapping) {

        var n1 = _settingsWorkerMapping[n2];
        if(n2!="s_bpercent") w[n2] = 0;
        if (n1 in s) {
            var v = parseFloat(s[n1]);
            if (!isNaN(v)) w[n2] = v;
        }
    }

    if ("period_hours" in w) {
        var ph = parseFloat(w.period_hours);
        if (!isNaN(ph) && ph>0) {
            if ("norms" in s && Array.isArray(s.norms)) {
                for (var j=s.norms.length-1; j>=0; j--) {
                    var isBreak = false;
                    var n = s.norms[j];
                    if ("hours" in n) {
                        var h = parseFloat(n.hours);
                        if (!isNaN(h) && ph>h) {
                            if ("norm" in n) {
                                var no = parseFloat(n.norm);
                                if (!isNaN(no)) {
                                    w.s_koutput =no;
                                    isBreak = true;
                                }
                            }
                            if ("bonus" in n) {
                                var no = parseFloat(n.bonus);
                                if (!isNaN(no)) {
                                    w.s_kbonus =no;
                                    isBreak = true;
                                }
                            }

                        }
                    }

                    if (isBreak) break;
                }
            }
        }
    }
}

function _reinitSettingWorkerProduction(w, res) {
	let prodWorkers = res.production
    let settingsProduction = res.settings.production

    if (w.select_id in prodWorkers) {
        var pw = prodWorkers[w.select_id];

        w.category_id = pw.category,
        w.post_code = pw.post_code,
        w.showname =  pw.name;
        w.worker_id = pw.id;
        w.doc_problem = pw.doc_problem;
        w.fired = pw.fired;
        w.recommened_category = pw.recommened_category;
        w.deposit_norm = parseFloat(pw.deposit_norm);
        if (isNaN(w.deposit_norm)) w.deposit_norm = 0;
        w.deposit = parseFloat(pw.deposit);
        if (isNaN(w.deposit)) w.deposit = 0;
        w.smenas = parseInt(pw.smenas);
        if (isNaN(w.smenas)) w.smenas = 0;

        if (!w.bonuses || w.bonuses.length==0)
            w.bonuses = pw.bonuses;

        if (!w.fines || w.fines.length==0)
            w.fines = pw.fines;

        w.period_hours = pw.period_hours;

        if (!w.post_code) {
            w.showpost = 'Без должности';
            w.is_no_post = true;
            w.post_code = 'no_post';
        } else if (w.post_code in settingsProduction) {
            var sp = settingsProduction[w.post_code];
            w.showpost = sp.name;
            w.position = sp.position;
            if (w.category_id in sp.categories) {
                var sc = sp.categories[w.category_id];
                w.category_number = sc.number;
                _initCategorySettingProduction(w, sc);
            }
        } else {
            w.showpost = 'Без должности';
            w.is_no_post = true;
            w.post_code = 'no_post';
        }

    } else {
        var parts = w.select_id.split("-");
        if (parts.length >= 1) {
            w.worker_id = parseInt(parts[0]);
            if (isNaN(w.worker_id)) w.worker_id = 0;
            
            var postCodeFromKey = parts.length > 1 ? parts[1] : 'no_post';
            if (postCodeFromKey === 'no_post' || !postCodeFromKey) {
                w.post_code = 'no_post';
                w.is_no_post = true;
                w.showpost = 'Без должности';
                w.position = 999999;
            } else {
                w.post_code = postCodeFromKey;
            }
            
            w.category_id = 0;
            w.category_number = 0;
            w.doc_problem = 0;
            w.fired = false;
            w.recommened_category = 0;
            w.deposit_norm = 0;
            w.deposit = 0;
            w.smenas = 0;
            w.bonuses = [];
            w.fines = [];
            w.period_hours = 0;
            
            if (!w.showname && w.worker_id) {
                var prodKey = w.worker_id + "-" + (w.post_code || 'no_post');
                if (res.production && prodKey in res.production) {
                    w.showname = res.production[prodKey].name;
                } else if (res.allDrivers && w.worker_id in res.allDrivers) {
                    w.showname = res.allDrivers[w.worker_id].name;
                } else if (res.drivers && w.worker_id in res.drivers) {
                    w.showname = res.drivers[w.worker_id].name;
                } else {
                    w.showname = 'Сотрудник #' + w.worker_id;
                }
            }
        }
    }
    return w;
}

function insertWorkerProduction(k, res) {
    var w = emptyWorkerProduction(1, res.calc);
    w.select_id = k;
    w=_reinitSettingWorkerProduction(w, res);
    return w;
}

function createEmptyPostForNoPostWorker() {
    return {
        post_code: 'no_post',
        showname: 'Без должности',
        position: 999999,
        s_norm: 0,
        s_bonus: 0,
        s_penalty: 0,
        s_over: 0,
        s_worktime_compens: 0,
        s_compens: 0,
        s_proceeds_min: 0,
        s_salmon: 0,
        s_penalty_max: 0,
        s_bonus_max: 0,
        s_bonus_amount: 0,
        s_personal_amount: 0,
        crm_sum: 0,
        crm_products: 0,
        crm_orders: 0,
        worktime: 0,
        worktime_correctly: 0,
        worktime_correctly_penalty: 0,
        salmon: 0,
        promo_rolls: 0,
        promo_soups: 0,
        normday: 0,
        normday_min: 0,
        sum_bonus: 0,
        sum_penalty: 0,
        sum_bonus_calc: 0,
        sum_penalty_calc: 0,
        sum_salary: 0,
        sum_compens: 0,
        sum_paid: 0,
        sum: 0,
        sum_round: 0,
        count_products: 0,
        surcharge_percent: 0,
        surcharge_fix: 0,
    };
}

function insertWorkerDriver(k, res) {
    var d;
    if (k in res.allDrivers) d = res.allDrivers[k]
    if (d) {
        var w = emptyDriver(res.calc)
        w.intervals =  [{start:moment("05:00", "HH:mm"), finish:moment("16:00", "HH:mm")}];
        w.worker_id = d.id;
        w.showname = d.name;
        w.doc_problem = d.doc_problem;
        w.fired = d.fired;
        w.bonuses = d.bonuses;
        w.fines = d.fines;
        w.bonus_amount = d.bonus_amount;
        w.bonus_amount_calc = d.bonus_amount;
        w.personal_amount = d.personal_amount;
        w.personal_amount_calc = d.personal_amount;
        w.orders_sum = 0;
        w.routes = 0;
        w.deposit_norm = 0;
        w.post_code = d.post_code;
        w.posts = d.posts;
        //if (!w.post_code) w.post_code="driver";
        if ("deposit_norm" in d) {
            w.deposit_norm = d.deposit_norm;
        }
        return w;
    }
}

export function eventAddWorkerProduction(sel, res) {
    var w =  insertWorkerProduction(sel, res)
    console.log(w);
    res.calc.production.workers.push(w);
    return recalcTableProduction(res)
}

export function  addWorkerAllButton(res) {
    let prodWorkers = res.production;
    var calc = res.calc;
    for (var c in prodWorkers) {
        var w = prodWorkers[c];
        if (w.is_filial &&
            (calc.calculation.smena==2 && w.work_shift_type!=="day"  || calc.calculation.smena==1 && w.work_shift_type!=="night")
        ) {
            var worker = calc.production.workers.findIndex((w) => { return w.select_id == c})
            if (worker<0) {
                var ww = insertWorkerProduction(c, res);
                calc.production.workers.push(ww);
            }
        }
    }
    return recalcTableProduction(res)
}



export function eventRemoveWorkerProduction(workerId, postCode, res) {
    var index = res.calc.production.workers.findIndex((w)=>{
        return w.worker_id==workerId && w.post_code==postCode;
    })
    if (index>=0) {
        res.calc.production.workers.splice(index, 1);
    }
    return recalcTableProduction(res)
}

export function eventRemovePostProduction(postCode, res)
{
    let index = 0;
    while (index>=0) {
        index = res.calc.production.workers.findIndex((w)=>{
            return w.post_code==postCode;
        })
        if (index>=0)
            res.calc.production.workers.splice(index, 1);
    }
    return recalcTableProduction(res)
}

export function eventRecalcDriver(d, res) {
    var calc  = res.calc;
    if (d) {
        for (var key in d) {
            var dr = d[key];
            var w = calc.drivers.workers.find( (w) => {
                return w.worker_id == dr.id;
            })
            if (w) {
                w.minus = dr.stat.minus;
                w.distance = dr.stat.distance / 1000;
                w.orders = dr.stat.orders;
                w.orders_sum = dr.stat.orders_sum;
                w.departure = dr.stat.departure;
                w.routes = dr.stat.routes;
                w.duration = dr.stat.duration / 60 / 60;
                w.plan_duration = dr.stat.plan_duration / 60 / 60;
                recalcTableDrivers(res)
            }
        }
    }
}


export function eventAddWorkerDriver(sel, res) {
    var w =  insertWorkerDriver(sel, res)
    //console.log("!!!!", w)
    res.calc.drivers.workers.push(w);
  //  console.log(w, 'ww');
    return recalcTableDrivers(res)
}

export function eventRemoveWorkerDriver(sel, res) {
    console.log("delte driver", sel, res)
    var index = res.calc.drivers.workers.findIndex((w)=>w.worker_id==sel)
    if (index>=0) {
        res.calc.drivers.workers.splice(index, 1);
    }
    return recalcTableDrivers(res)
}

export function eventUpdateFinesProduction(workerId, postCode, items, res) {
    var index = res.calc.production.workers.findIndex((w)=>w.worker_id==workerId && w.post_code==postCode)
    if (index>=0) {
        var w = res.calc.production.workers[index]
        w.fines = [];
        items.forEach((i) => {
            w.fines.push({
                amount : parseFloat(i.amount),
                id : i.id,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
    return recalcTableProduction(res)
}

export function eventAddBonusFineAll(t, w, i, res) {
    var workers = w=="production" ? res.calc.production.workers : res.calc.drivers.workers;
    workers.forEach((worker) => {
        var items = t=="bonus" ? worker.bonuses : worker.fines;
        items.push({
            amount : parseFloat(i.amount),
            id : i.id,
            reason_id : i.reason_id,
            reason : i.reason,
            author_id : i.author_id,
        })
    })
    if (w=="production") recalcTableProduction(res); else recalcTableDrivers(res);
}



export function eventUpdateBonusesProduction(workerId, postCode, items, res) {
    var index = res.calc.production.workers.findIndex((w)=>w.worker_id==workerId && w.post_code==postCode)
    if (index>=0) {
        var w = res.calc.production.workers[index]
        w.bonuses = [];
        items.forEach((i) => {
            w.bonuses.push({
                amount : parseFloat(i.amount),
                id : i.id,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
    return recalcTableProduction(res)
}

export function eventUpdateFinesDrivers(sel, items, res) {
    var index = res.calc.drivers.workers.findIndex((w)=>w.worker_id==sel)
    if (index>=0) {
        var w = res.calc.drivers.workers[index]
        w.fines = [];
        items.forEach((i) => {
            w.fines.push({
                amount : parseFloat(i.amount),
                id : i.id,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
    return recalcTableDrivers(res)
}

export function eventUpdatePersonalDriver(sel, items, res) {
    var index = res.calc.drivers.workers.findIndex((w)=>w.worker_id==sel)
    if (index>=0) {
        var w = res.calc.drivers.workers[index]
        w.personal_history = [];
        items.forEach((i) => {
            w.personal_history.push({
                amount : parseFloat(i.amount),
                id : i.id,
                type: i.type,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
    return recalcTableDrivers(res)
}

export function eventUpdatePersonalProduction(workerId, postCode, items, res) {
    var index = res.calc.production.workers.findIndex((w)=>w.worker_id==workerId && w.post_code==postCode)
    if (index>=0) {
        var w = res.calc.production.workers[index]
        w.personal_history = [];
        items.forEach((i) => {
            w.personal_history.push({
                amount : parseFloat(i.amount),
                id : i.id,
                type: i.type,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
   return recalcTableProduction(res)
}

export function eventUpdateBonusesDrivers(sel, items, res) {
    var index = res.calc.drivers.workers.findIndex((w)=>w.worker_id==sel)
    if (index>=0) {
        var w = res.calc.drivers.workers[index]
        w.bonuses = [];
        items.forEach((i) => {
            w.bonuses.push({
                amount : parseFloat(i.amount),
                id : i.id,
                reason_id : i.reason_id,
                reason : i.reason,
                author_id : i.author_id,
            })
        })
    }
    return recalcTableDrivers(res)
}

export function eventChangeIntervalsProduction(workerId, postCode, items, res) {
    var index = res.calc.production.workers.findIndex((w)=>w.post_code==postCode && w.worker_id==workerId)
    if (index>=0) {
        var w = res.calc.production.workers[index]
        w.intervals = [];
        items.forEach((i) => {
            w.intervals.push({start:moment(i.start, "HH:mm"), finish:moment(i.end, "HH:mm")})
        })
    }
    return recalcTableProduction(res)
}
export function eventChangeCategory(workerId, postCode, v, res) {
    let index = res.calc.production.workers.findIndex((w)=>w.post_code==postCode && w.worker_id==workerId)
    if (index>=0) {
        let w = res.calc.production.workers[index];
        let settingsProduction = res.settings.production
        if (w.post_code in settingsProduction) {
            let sp = settingsProduction[w.post_code];
            if (v in sp.categories) {
                w.category_id = v;
                let sc = sp.categories[w.category_id];
                w.category_number = sc.number;
                _initCategorySettingProduction(w, sc);
                console.log("changeRank")
                return recalcTableProduction(res)
            }
        }
    }
}

export function eventChangeIntervalsDrivers(sel, items, res) {
    var index = res.calc.drivers.workers.findIndex((w)=>w.worker_id==sel)
    if (index>=0) {
        var w = res.calc.drivers.workers[index]
        w.intervals = [];
        items.forEach((i) => {
            w.intervals.push({start:moment(i.start, "HH:mm"), finish:moment(i.end, "HH:mm")})
        })
    }
    return recalcTableDrivers(res)
}

function  emptyPostProduction() {
    return {
        post_code : '',
        type_load : '',
        type_load_unit : '',
        type_load_name : '',
        type_load_is_system : 1,
        s_norm : 0,
        s_bonus :  0,
        s_penalty : 0,
        s_over: 0,
        s_worktime_compens : 0,
        s_compens : 0,
        s_proceeds_min : 0,
        s_salmon : 0,
        s_penalty_max : 0,
        s_bonus_max : 0,
        crm_sum : 0,
        crm_products : 0,
        crm_orders : 0,
        worktime : 0,
        worktime_correctly : 0,
        worktime_correctly_penalty : 0,
        salmon : 0,
        promo_rolls: 0,
        promo_soups : 0,
        normday : 0,
        normday_min : 0,
        sum_bonus : 0,
        sum_penalty : 0,
        sum_bonus_calc : 0,
        sum_penalty_calc : 0,
        sum_salary : 0,
        sum_compens : 0,
        sum_paid : 0,
        sum : 0,
        sum_round : 0,
        count_products : 0,
        showname : "",
        surcharge_percent : 0,
        surcharge_fix : 0,
    }
}


function _initPostProduction(c, res) {
    let settingsProduction = res.settings.production

    if (!settingsProduction[c] || !settingsProduction[c].s) {
        var postFallback = emptyPostProduction();
        postFallback.post_code = c;
        return postFallback;
    }

    var s = settingsProduction[c].s;
    var post =emptyPostProduction();
    post.post_code = c;

    var _settingsPostMapping = {
        s_norm : 'norm',
        s_normup : 'norm_up',
        s_bonus :  'bonus',
        s_penalty :  'penalty',
        s_over: 'over',
        s_worktime_compens : 'workTime_compens',
        s_compens : 'compens',
        s_proceeds_min : 'proceeds_min',
        s_salmon : 'salmon',
        s_penalty_max : 'penalty_max',
        s_bonus_max : 'bonus_max',
        s_bonus_amount : 'bonus_amount',
        s_personal_amount : 'personal_amount',
        //депозит
        s_dep_shift_payment : "shift_payment",
        s_dep_min_salary : "dep_min_salary",
        s_dep_shift_count : "shift_count",
        s_dep_rank : "rank",
        s_dep_filial_attached : "filial_attached",
        s_dep_handmode : "deposit_handmode",
        s_dep_payment_typed : "shift_payment_type",
        s_order_types : []
    }

    for (var n2 in _settingsPostMapping) {
    	var n1 = _settingsPostMapping[n2];

        post[n2] = 0;
        if (n1 in s) {
            if (n1=="shift_payment_type") {
                post[n2] = s[n1];
            } else if (n1=="norm_up") {
                post[n2] = s[n1];
            } else {
                var v = parseFloat(s[n1]);

                if (!isNaN(v)) post[n2] = v;
                else if (n1=="s_penalty_max" || n2=="s_bonus_max") {
                    post[n2] = null;
                }
            }
        }


    }

    post["type_load"] = '';
    if ("type_load" in s && s["type_load"]) {
        post["type_load"] = s["type_load"];
    }
    post["type_load_name"] = '';
    if ("type_load_name" in s && s["type_load_name"]) {
        post["type_load_name"] = s["type_load_name"];
    }
    post["type_load_is_system"] = 1;
    if ("type_load_is_system" in s) {
        post["type_load_is_system"] = s["type_load_is_system"];
    }
    post["type_load_unit"] = 1;
    if ("unit_id" in s && s["unit_id"]) {
        post["type_load_unit"] = s["unit_id"];
    }

    post["order_types"] = {};
    if ("order_type" in s && Array.isArray(s.order_type)) {
        post["s_order_types"] = s.order_type;
    }

    post.outworks = [];
    if ("outworks" in settingsProduction[c] && Array.isArray(settingsProduction[c].outworks)) {
        post.outworks = settingsProduction[c].outworks;
    }


    if ("iiko_places" in s && Array.isArray(s.iiko_places)) {
        post["s_places"] = s.iiko_places;
    }

    post.outworks = [];
    if ("outworks" in settingsProduction[c] && Array.isArray(settingsProduction[c].outworks)) {
        post.outworks = settingsProduction[c].outworks;
    }

    post.showname = settingsProduction[c].name;
    post.position = settingsProduction[c].position;

    return post;
}

function _initPostsProduction(res) {
    var posts = [], t = this;
    let settingsProduction = res.settings.production

   	for (var c in settingsProduction) {
        if (c!="driver") {
            var post = _initPostProduction(c, res);
            posts.push(post);
        }
    }
    return posts;
}

function  emptyTotalProduction(workers, posts, totalSettings) {
    if (!workers) workers = [];
    if (!posts) posts = [];
    return {
        worktime : 0,
        worktime_correctly : 0,
        worktime_correctly_penalty : 0,
        salmon : 0,
        promo_rolls: 0,
        promo_soups: 0,
        sum_bonus : 0,
        fine_id : 0,
        bonus_id : 0,
        author_bonus :  0,
        author_fine :  0,
        sum_penalty : 0,
        sum_bonus_calc : 0,
        sum_penalty_calc : 0,
        sum_salary : 0,
        sum_compens : 0,
        sum : 0,
        sum_round : 0,
        sum_paid : 0,
        crm_products : 0,
        crm_sum : 0,
        workers : workers,
        posts : posts,
        normday : 0,
        proceeds_office_normday : 0,
        crm_orders : 0,
        proceeds_office_normday_min : 0,
        rounding_zp : totalSettings.rounding_zp,
        doc_problem: 0,
        fired: false,
    }
}

export function findPostProduction(code, calc) {
	return calc.production.posts.find(function(p){
		return p.post_code == code;
	})
}

export function findPostDriver(code, calc) {
    return calc.drivers.posts.find(function(p){
        return p.post_code == code;
    })
}

function initSurchargesProduction(calc, surcharges) {
    calc.production.posts.forEach(function(p) {
        var k =p.post_code;
        if (k in surcharges && Array.isArray(surcharges[k])) {
            surcharges[k].forEach(function(s, i){
                if ("fix" in surcharges[k][i]) {
                    var s = parseFloat(surcharges[k][i].fix);
                    surcharges[k][i].fix = s;
                }
                if ("percent" in surcharges[k][i]) {
                    var s = parseFloat(surcharges[k][i].percent);
                    surcharges[k][i].percent = s;
                }

            })

            p.surcharges = surcharges[k];
        }
    })
}

    //инициализируем данными из crm
function _initCRMProduction(res) {
	let calc=res.calc
	let total=res.total
	let surcharges = res.surcharges
    initSurchargesProduction(calc, surcharges)

    calc.production.crm_sum = parseFloat(total.sum.sum);
    if (isNaN(calc.production.crm_sum)) calc.production.crm_sum=0;
    calc.production.crm_orders = parseFloat(total.sum.count);
    if (isNaN(calc.production.crm_orders)) calc.production.crm_orders=0;
    calc.production.crm_products = parseFloat(total.sum.orders);
    if (isNaN(calc.production.crm_products)) calc.production.crm_products=0;

    calc.production.posts.forEach(function(p) {
        var k =p.post_code;
        calc.production.aorders = {};
        calc.production.aorders_count = {};
        if (total.sum.aorders && typeof total.sum.aorders == 'object') {
            calc.production.aorders = total.sum.aorders;
        }
        if (total.sum.aorders_count && typeof total.sum.aorders_count == 'object') {
            calc.production.aorders_count = total.sum.aorders_count;
        }

        var crm_sum = 0, crm_products=0, crm_orders=0, salmon=0, promo_rolls=0, promo_soups=0, promo_lunch=0, promo_pizza=0, promo_hot=0;
        var aorders = {};
        var aorders_count = {};

        if (p.type_load == "proceeds_order_type") {
            crm_sum = 0;
            if (Array.isArray(p.s_order_types)) {
                p.s_order_types.forEach(function(rr){
                    var key = "";
                    if (rr=="hall") key = "ORDER_WITHOUT_DELIVERY";
                    else if (rr=="delivery") key = "DELIVERY_BY_COURIER";
                    else if (rr=="pickup") key = "DELIVERY_PICKUP";
                    if ('types' in total && key in total.types) {
                        crm_sum += total.types[key].sum;
                    }
                })
            }
        } else if (p.type_load == "products_place" || p.type_load=="proceeds_place") {
            crm_sum = 0; crm_products = 0;
            if (Array.isArray(p.s_places)) {
                p.s_places.forEach(function(rr){
                    if ('places' in total && rr in total.places) {
                        crm_sum += total.places[rr].sum;
                        crm_products += total.places[rr].orders;
                    }
                })
            }
        } else if (p.type_load=="proceeds_office" || p.type_load=="proceeds_percent") {
            crm_sum = parseFloat(total.sum.sum);
            crm_products = parseFloat(total.sum.count);
            crm_orders = parseFloat(total.sum.orders);
            salmon = 0;
        } else if (k=="suhi"){
            crm_sum = parseFloat(total.sushi.sum);
            crm_products = parseFloat(total.sushi.count);
            crm_orders = parseFloat(total.sushi.orders);
            if ("promo_rolls" in total.sum) {
                promo_rolls = parseFloat(total.sum.promo_rolls);
            }

            if ("promo_soups" in total.sum) {
                promo_soups = parseFloat(total.sum.promo_soups);
            }

            if ("promo_hot" in total.sum) {
                promo_hot = parseFloat(total.sum.promo_hot);
            }
            if ("promo_lunch" in total.sum) {
                promo_lunch = parseFloat(total.sum.promo_lunch);
            }
            if ("promo_pizza" in total.sum) {
                promo_pizza = parseFloat(total.sum.promo_pizza);
            }

            if ("aorders" in total.sushi) {
                aorders = total.sushi.aorders;
            }
            if ("aorders_count" in total.sushi) {
                aorders_count = total.sushi.aorders_count;
            }

            salmon = parseFloat(total.sum.salmon);
        } else if (k=="pizzamaker") {
            crm_sum = parseFloat(total.pizza.sum);
            crm_products = parseFloat(total.pizza.count);
            crm_orders = parseFloat(total.pizza.orders);
            salmon = 0;
        } else if (k=="European cook") {
            crm_sum = parseFloat(total["European cook"].sum);
            crm_products = parseFloat(total["European cook"].count);
            crm_orders = parseFloat(total["European cook"].orders);
            salmon  =0;
        }
        if (total.sum.surcharges && p.post_code in total.sum.surcharges) {
            p.post_surcharge=total.sum.surcharges[p.post_code];
        } else {
            p.post_surcharge=0;
        }

        if (!isNaN(crm_sum)) p.crm_sum=crm_sum;
        if (!isNaN(crm_products)) p.crm_products=crm_products;
        if (!isNaN(crm_orders)) p.crm_orders=crm_orders;
        if (!isNaN(salmon)) p.salmon=salmon;
        p.aorders = aorders;
        p.aorders_count = aorders_count;

        if (!isNaN(promo_rolls)) p.promo_rolls=promo_rolls;
        if (!isNaN(promo_soups)) p.promo_soups=promo_soups;
        if (!isNaN(promo_lunch)) p.promo_lunch=promo_lunch;
        if (!isNaN(promo_hot)) p.promo_hot=promo_hot;
        if (!isNaN(promo_pizza)) p.promo_lunch=promo_pizza;

        if (p.type_load=="proceeds_office") {
           // calc.production.crm_sum = p.crm_sum;
            calc.production.crm_orders = p.crm_orders;
            calc.production.crm_products = p.crm_products;

        }else if (k=="suhi") {
            calc.production.promo_rolls = p.promo_rolls;
            calc.production.promo_lunch = p.promo_lunch;
            calc.production.promo_soups = p.promo_soups;
            calc.production.promo_hot = p.promo_hot;
            calc.production.promo_pizza = p.promo_pizza
        }

        if (p.type_load!=="proceeds_office"  && p.type_load!=='proceeds_percent') {
           if ("outworks" in p && Array.isArray(p.outworks)) {
                p.outworks.forEach(function(rr){
                    let key = "";
                    if (rr.order_type==1) key = "ORDER_WITHOUT_DELIVERY";
                    else if (rr.order_type==2) key = "DELIVERY_BY_COURIER";
                    else if (rr.order_type==3) key = "DELIVERY_PICKUP";
                    var v = parseFloat(rr.outwork_value);

                    if (v) {
                        if ('types' in total && key in total.types) {
                            p.crm_sum += total.types[key].sum * v /100;
                        }
                    }
                })
           }
        }


        if (k=="pizzamaker") {
            if ("pizza" in total && "count" in total.pizza) {
                p.count_products =  parseInt(total.pizza.count);
                if (isNaN(p.count_products)) p.count_products = 0;
            }
        }

        if (isAdmin(k) || k=="franchise administrator" || k=="admin_smeny" || (k && k.indexOf("administrator") !== -1)) {
            if ("night" in total) {
                var night = parseFloat(total.night.sum);
                if (!isNaN(night)) {
                    p.crm_sum = p.crm_sum - night;
                }
            }
            if ("pluski_discount_sum" in total.sum) {
                p.pluski_discount_sum = parseFloat(total.sum.pluski_discount_sum);
                if (isNaN(p.pluski_discount_sum)) p.pluski_discount_sum = 0;
            }
        }
    })


}

export function eventChangeSalmon(v, res) {
    var post = findPostProduction("suhi", res.calc);;
    post.salmon = v;
    recalcTableProduction(res)
}

export function eventChangeLoad(v, code, res) {

    var post = findPostProduction(code, res.calc);
    console.log(v, code, res, post.crm_sum);
    if (post) post.crm_sum=v
   recalcTableProduction(res)
}

export function addReasonSurcharge(workerId, postCode, ssID, sum, res) {
    console.log(workerId, postCode, ssID, sum, res)
    var index = res.calc.production.workers.findIndex((w)=>w.post_code==postCode && w.worker_id==workerId)
    if (index>=0) {
        var worker = res.calc.production.workers[index];
        worker.reason_surcharge_id = ssID;
        worker.sum_compens = parseFloat(sum);
        //con
        recalcTableProduction(res)
    }
}


function recalcTotalProduction(result, newFilial, schedule=false, isNew) {
	let calc = result.calc
	schedule = result.shedule
	let total = null
	if ("total" in result) total=result.total
	let remotes = result.remotes
    let attendances = result.attendances
	let totalSettings = result.total_settings
    
    if (!('no_post' in result.settings.production)) {
        result.settings.production['no_post'] = {
            code: 'no_post',
            name: 'Без должности',
            position: 999999,
            type: 'production',
            s: {
                norm: 0,
                bonus: 0,
                penalty: 0,
                over: 0,
                workTime_compens: 0,
                compens: 0,
                proceeds_min: 0,
                salmon: 0,
                penalty_max: 0,
                bonus_max: 0,
                bonus_amount: 0,
                personal_amount: 0,
                shift_payment: 0,
                dep_min_salary: 0,
                shift_count: 0,
                rank: 0,
                filial_attached: 0,
                deposit_handmode: 0,
                shift_payment_type: 'rub',
            },
            categories: {}
        };
    }
    
    if (newFilial) {
        calc.production.workers = [];
    }

    if (schedule && calc.production.workers.length==0) {
        schedule.forEach(function(s, pc) {
            s.forEach(function(is, wid) {
                var key = wid + "-" + pc;
                var w = insertWorkerProduction(key, result);
                if (!w || !w.post_code) return ;
                w.intervals = [];
                w.sum_deposit = 0;
                is.forEach(function(i){
                    w.intervals.push(
                        {start:moment(i[0], "HH:mm"), finish:moment(i[1], "HH:mm")}
                    );
                })
                calc.production.workers.push(w);
            })
        })
    }
    
    var scheduleWorkers = [];
    if (schedule) {
        schedule.forEach(function(s, pc) {
            s.forEach(function(is, wid) {
                var key = wid + "-" + pc;
                scheduleWorkers.push(key);
            })
        })
    }
    
    var newRemotesKeys = [];
    if (remotes) {
        for (var id in remotes) {
            var r = remotes[id];
            var postCode = r.post || null;
            var key = id + "-" + (postCode || 'no_post');
            newRemotesKeys.push(key);
        }
    }
    
    var newAttendancesKeys = [];
    if (attendances) {
        for (var id in attendances) {
            var a = attendances[id];
            var key = id + "-" + a.post;
            newAttendancesKeys.push(key);
        }
    }
    
    if (remotes || attendances) {
        calc.production.workers = calc.production.workers.filter(function(w) {
            return scheduleWorkers.indexOf(w.select_id) !== -1 || 
                   newRemotesKeys.indexOf(w.select_id) !== -1 || 
                   newAttendancesKeys.indexOf(w.select_id) !== -1;
        });
    }
    
    if (remotes) {
        for (var id in remotes) {
            var r = remotes[id]
            var postCode = r.post || null;
            var key = id + "-" + (postCode || 'no_post');
            
            var existingWorker = calc.production.workers.find(function(w) { 
                return w.select_id === key || w.select_id === (id + "-null") || w.select_id === id; 
            });
            
            if (existingWorker) {
                if (existingWorker.select_id !== key) {
                    existingWorker.select_id = key;
                }
                existingWorker.intervals = [];
                existingWorker.correction_type = r.correction_type;
                existingWorker.confidence_level = r.confidence_level;
                if (r.name && !existingWorker.showname) {
                    existingWorker.showname = r.name;
                }
                var smena = calc.calculation.smena;
                var timebeg = calc.calculation.timebeg ? moment(calc.calculation.timebeg, "HH:mm:ss") : null;
                var timeend = calc.calculation.timeend ? moment(calc.calculation.timeend, "HH:mm:ss") : null;
                
                r.intervals.forEach(function(i) {
                    var intervalStart = moment(i.start_time, "HH:mm");
                    var intervalEnd = moment(i.end_time, "HH:mm");
                    
                    var shouldAdd = false;
                    
                    if (timebeg && timeend) {
                        if (timebeg.isBefore(timeend)) {
                            shouldAdd = (intervalStart.isSameOrAfter(timebeg) && intervalStart.isBefore(timeend)) ||
                                        (intervalEnd.isAfter(timebeg) && intervalEnd.isSameOrBefore(timeend)) ||
                                        (intervalStart.isBefore(timebeg) && intervalEnd.isAfter(timeend));
                        } else {
                            shouldAdd = intervalStart.isSameOrAfter(timebeg) || intervalStart.isBefore(timeend) ||
                                        intervalEnd.isAfter(timebeg) || intervalEnd.isSameOrBefore(timeend) ||
                                        (intervalStart.isBefore(timeend) && intervalEnd.isAfter(timebeg));
                        }
                    } else {
                        if (smena == 2) {
                            shouldAdd = (intervalStart.format("HH:mm") >= '16:00' || intervalStart.format("HH:mm") < "05:00");
                        } else {
                            shouldAdd = (intervalStart.format("HH:mm") < '16:00' && intervalStart.format("HH:mm") >= "05:00");
                        }
                    }
                    
                    if (shouldAdd) {
                        existingWorker.intervals.push(
                            {start: intervalStart, finish: intervalEnd}
                        );
                    }
                })
                
                if (existingWorker.intervals.length === 0) {
                    if (smena == 2) {
                        var defaultStart = moment("16:00", "HH:mm");
                        var defaultEnd = moment("05:00", "HH:mm");
                        if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                            defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                        }
                        if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                            defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                        }
                        existingWorker.intervals.push({start: defaultStart, finish: defaultEnd});
                    } else if (smena == 1) {
                        var defaultStart = moment("05:00", "HH:mm");
                        var defaultEnd = moment("16:00", "HH:mm");
                        if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                            defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                        }
                        if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                            defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                        }
                        existingWorker.intervals.push({start: defaultStart, finish: defaultEnd});
                    }
                }
            } else {
                var w = emptyWorkerProduction(1, result.calc, true);
                w.select_id = key;
                w = _reinitSettingWorkerProduction(w, result);

                if (!w) {
                    continue ;
                }

                w.intervals = [];
                w.correction_type = r.correction_type;
                w.confidence_level = r.confidence_level;
                if (r.name) {
                    w.showname = r.name;
                }

                var smena = calc.calculation.smena;
                var timebeg = calc.calculation.timebeg ? moment(calc.calculation.timebeg, "HH:mm:ss") : null;
                var timeend = calc.calculation.timeend ? moment(calc.calculation.timeend, "HH:mm:ss") : null;
                
                r.intervals.forEach(function(i) {
                    var intervalStart = moment(i.start_time, "HH:mm");
                    var intervalEnd = moment(i.end_time, "HH:mm");
                    
                    var shouldAdd = false;
                    
                    if (timebeg && timeend) {
                        if (timebeg.isBefore(timeend)) {
                            shouldAdd = (intervalStart.isSameOrAfter(timebeg) && intervalStart.isBefore(timeend)) ||
                                        (intervalEnd.isAfter(timebeg) && intervalEnd.isSameOrBefore(timeend)) ||
                                        (intervalStart.isBefore(timebeg) && intervalEnd.isAfter(timeend));
                        } else {
                            shouldAdd = intervalStart.isSameOrAfter(timebeg) || intervalStart.isBefore(timeend) ||
                                        intervalEnd.isAfter(timebeg) || intervalEnd.isSameOrBefore(timeend) ||
                                        (intervalStart.isBefore(timeend) && intervalEnd.isAfter(timebeg));
                        }
                    } else {
                        if (smena == 2) {
                            shouldAdd = (intervalStart.format("HH:mm") >= '16:00' || intervalStart.format("HH:mm") < "05:00");
                        } else {
                            shouldAdd = (intervalStart.format("HH:mm") < '16:00' && intervalStart.format("HH:mm") >= "05:00");
                        }
                    }
                    
                    if (shouldAdd) {
                        w.intervals.push(
                            {start: intervalStart, finish: intervalEnd}
                        );
                    }
                })
                
                if (w.intervals.length === 0) {
                    if (smena == 2) {
                        var defaultStart = moment("16:00", "HH:mm");
                        var defaultEnd = moment("05:00", "HH:mm");
                        if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                            defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                        }
                        if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                            defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                        }
                        w.intervals.push({start: defaultStart, finish: defaultEnd});
                    } else if (smena == 1) {
                        var defaultStart = moment("05:00", "HH:mm");
                        var defaultEnd = moment("16:00", "HH:mm");
                        if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                            defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                        }
                        if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                            defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                        }
                        w.intervals.push({start: defaultStart, finish: defaultEnd});
                    }
                }

                if (w.intervals.length>0) {
                    calc.production.workers.push(w);
                }
            }
        }
    }

    var smena = calc.calculation.smena;
    if (attendances) {
        for (let id in attendances) {
            let r = attendances[id];
            var key = id + "-" + r.post;
            var w  = calc.production.workers.find((r) => r.select_id==key );
            if (!w) {
                w = insertWorkerProduction(key, result);
                if (!w) continue;
                calc.production.workers.push(w);
                w  = calc.production.workers.find((r) => r.select_id==key );
            }
            if (!w) {
                return ;
            }

            w.intervals = [];
            r.intervals.forEach(function(i) {
                if (!i.end_time) i.end_time='20:00';
                if (
                    (smena==2 && i.start_time>='17:00') ||  (smena==1 && i.start_time<'17:00')
                ) {
                    w.intervals.push(
                        {start:moment(i.start_time, "HH:mm"), finish:moment(i.end_time, "HH:mm")}
                    );
                }
            })
            
            if (w.intervals.length === 0) {
                if (smena == 2) {
                    var defaultStart = moment("16:00", "HH:mm");
                    var defaultEnd = moment("05:00", "HH:mm");
                    if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                        defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                    }
                    if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                        defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                    }
                    w.intervals.push({start: defaultStart, finish: defaultEnd});
                } else if (smena == 1) {
                    var defaultStart = moment("05:00", "HH:mm");
                    var defaultEnd = moment("16:00", "HH:mm");
                    if (calc.calculation && calc.calculation.timebeg && moment(calc.calculation.timebeg, "HH:mm:ss").isValid()) {
                        defaultStart = moment(calc.calculation.timebeg, "HH:mm:ss");
                    }
                    if (calc.calculation && calc.calculation.timeend && moment(calc.calculation.timeend, "HH:mm:ss").isValid()) {
                        defaultEnd = moment(calc.calculation.timeend, "HH:mm:ss");
                    }
                    w.intervals.push({start: defaultStart, finish: defaultEnd});
                }
            }

        }
    }


    var posts = _initPostsProduction(result)
    calc.production = emptyTotalProduction(calc.production.workers, posts, totalSettings);


    if (total && "waiters" in total && typeof total.waiters=='object') {
        var post = findPostProduction("waiter", calc);
        if (post)  {
        	for (var id in total.waiters) {
        		var ww = total.waiters[id];
                var key = id + "-" + "waiter";
                var id=key, ind = -1, i=0, post_code = null;
                while (ind<0 && i<calc.production.workers.length) {
                    if (calc.production.workers[i].select_id==id) {
                        ind = i;
                        post_code =calc.production.workers[i].post_code;
                    }
                    i++;
                }
                if (ind>=0) {
                    calc.production.workers.splice(ind, 1);
                }
                var w = insertWorkerProduction(key, result);
                if (!w || !w.post_code) {
                    return ;
                }

                if (post.type_load=="orders_employee") {
                    w.count_products = ww.orders;
                } else if (post.type_load=="proceeds_employee") {
                    w.count_products = ww.sum;
                } else if (post.type_load=="products_employee" ){
                    w.count_products = ww.count;
                }

                calc.production.workers.push(w);
            }
        }
    }


    if (total && "operators" in total && typeof total.operators=='object') {
        var post = findPostProduction("operator", calc);

        if (post)  {
        	for (var id in total.operators) {
        		var ww = total.operators[id];
                var key = id + "-" + "operator";
                var w = insertWorkerProduction(key, result);
                if (!w || !w.post_code) {
                    return ;
                }
                if (post.type_load=="orders_employee") {
                    w.count_products = ww.orders;
                } else if (post.type_load=="proceeds_employee") {
                    w.count_products = ww.sum;
                } else if (post.type_load=="products_employee" ){
                    w.count_products = ww.count;
                }
                calc.production.workers.push(w);
            }
        }
    }


    _initCRMProduction(result)

    calc.production.workers.forEach(function(w){
        _reinitSettingWorkerProduction(w, result);
        if (w && isNew) {
            for (var ii in w.intervals) {
                w.intervals[ii].finish =  moment(new Date());
            }
        }
        if ("sum_deposit" in w && typeof w.sum_deposit == "number" && "sum_deposit" in w) {
            w.deposit = w.deposit - w.sum_deposit;
        }
        if (w.deposit<0) {
            w.deposit = 0;
        }
    })

    recalcTableProduction(result)
    return result

}

export function isAdmin(post_code) {
    return (
        post_code == "administrator" ||
        post_code == "administrator mladshyi"  ||
        post_code == "admin stager" ||
        post_code == "st. admin"  ||
        post_code == "franchise administratrator" ||
        post_code == "Oficiant-sborka" ||
        post_code == "Ypakovshik" ||
        post_code == "Mladshiy menedzher po prodazham" ||
        post_code == "Specialist v oblasti podgotovki i razvitiya personala"
    );
}

function getPluskiDiscountSumForAdmin(calc, res, post) {
    var pluskiDiscountSum = 0;
    if (post && "pluski_discount_sum" in post) {
        pluskiDiscountSum = parseFloat(post.pluski_discount_sum);
        if (isNaN(pluskiDiscountSum)) {
            pluskiDiscountSum = 0;
        }
    }

    if (pluskiDiscountSum === 0 && calc && calc.production && Array.isArray(calc.production.posts)) {
        calc.production.posts.forEach(function(postModel) {
            if (pluskiDiscountSum !== 0) {
                return;
            }
            if (postModel && postModel.post_code && (postModel.post_code.indexOf("administrator") !== -1 || postModel.post_code === "admin_smeny")) {
                var postPluskiDiscountSum = parseFloat(postModel.pluski_discount_sum);
                if (!isNaN(postPluskiDiscountSum) && postPluskiDiscountSum !== 0) {
                    pluskiDiscountSum = postPluskiDiscountSum;
                }
            }
        });
    }

    if (pluskiDiscountSum === 0 && res && res.total && res.total.sum && "pluski_discount_sum" in res.total.sum) {
        var totalPluskiDiscountSum = parseFloat(res.total.sum.pluski_discount_sum);
        if (!isNaN(totalPluskiDiscountSum)) {
            pluskiDiscountSum = totalPluskiDiscountSum;
        }
    }

    return pluskiDiscountSum;
}

export function isCook(post_code) {
    return ["suhi", "STsuhi", "Suhihot"].indexOf(post_code)>=0
}

function isNumber(myVar) {
  return   typeof myVar === 'number'
}

/**
 * Разряд 404: не учитывается фикс. дневной оклад
 */
export function isProductionRankWithoutFixedSalary(categoryNumber) {
    var n = Number(categoryNumber);
    if (isNaN(n)) {
        return false;
    }
    return n === 404;
}

/**
 * Разряды 0 и 404: не начисляется премия за прев. норматива
 * - у 404 оклад не начисляется (см. isProductionRankWithoutFixedSalary)
 * - у 0 оклад начисляется
 */
export function isProductionRankWithoutExceedingPremiumBonus(categoryNumber) {
    var n = Number(categoryNumber);
    if (isNaN(n)) {
        return false;
    }
    return n === 0 || n === 404;
}

export function recalcTableProduction(res, startSmena, endSmena, smena) {
    var additionalSuhi =0;
    let calc = res.calc
    let prodWorkers = res.production
    let settingsProduction = res.settings.production
    let totalSettings = res.total_settings
    let pizzamaker_non_standart  = res.pizzamaker_non_standart
    if (!smena) smena = 1;
    

    for (var i in prodWorkers) {
        var w = prodWorkers[i];
        if ("personal_amount" in w && w.personal_amount && !("personal_amount_calc" in w)) {
            w.personal_amount_calc = w.personal_amount;
        } else if (!("personal_amount_calc" in w)) {
            w.personal_amount_calc = 0;
            w.personal_amount = 0;
        }
        w.bonus_amount = 0;
        w.bonus_amount_calc = w.bonus_amount;

    }

    if (!startSmena)  startSmena = "05:00";
    if (!endSmena)  endSmena = "16:00";

    calc.production.posts.forEach(function(p){
        if (startSmena && endSmena) {
            if (p.post_code in settingsProduction) {
                var s = settingsProduction[p.post_code].s;
                if ("timesettings" in s && Array.isArray(s.timesettings) && s.timesettings.length>0) {
                    s.timesettings.forEach(function(ts){
                        if (startSmena==ts.start && endSmena==ts.end) {
                            var params = {
                                bonus: "s_bonus",
                                bonus_max: "s_bonus_max",
                                compens: "s_compens",
                                norm: "s_norm",
                                over: "s_over",
                                penalty: "s_penalty",
                                penalty_max: "s_penalty_max",
                                proceeds_min: "s_proceeds_min",
                                salmon: "s_salmon",
                                workTime_compens: "s_worktime_compens",
                            };
                            for (var kk in params) {
                                var vv = params[kk];
                                var b = parseFloat(ts[kk]);
                                if (!isNaN(b)) {
                                    p[vv] = b;
                                }
                            }
                        }
                    })
                }
            }
        }

        p.normday = 0;
        p.normday_min = 0;
        p.sum = 0;
        p.sum_round = 0;
        p.sum_bonus = 0;
        p.sum_bonus_calc = 0;
        p.sum_penalty = 0;
        p.sum_penalty_calc = 0;
        p.sum_compens = 0;
        p.sum_salary = 0;
        p.worktime = 0;
        p.worktime_correctly = 0;
        p.worktime_correctly_penalty = 0;
        p.count_workers = 0;
    })

    var proceeds_office_normday = 0;
    var proceeds_office_normday_min = 0;
    var proceeds_suhi_normday = 0;
    var proceeds_suhi_normday_min = 0;

    calc.production.normday = 0;
    calc.production.sum = 0;
    calc.production.sum_bonus = 0;
    calc.production.bonus_id = 0;
    calc.production.fine_id = 0;
    calc.production.author_bonus =  0;
    calc.production.author_fine =  0;
    calc.production.sum_bonus_calc = 0;
    calc.production.sum_penalty = 0;
    calc.production.sum_penalty_calc = 0;
    calc.production.sum_compens = 0;
    calc.production.sum_salary = 0;
    calc.production.worktime = 0;
    calc.production.worktime_correctly = 0;
    calc.production.worktime_correctly_penalty = 0;
    calc.production.count_workers = 0;
    //для рассчета средних коэффициентов
    calc.production.sum_s_koutput = 0;
    calc.production.sum_s_kbonus = 0;
    calc.production.sum_s_kpenalty = 0;
    calc.production.count_workers_s_koutput = 0;
    calc.production.count_workers_s_kbonus = 0;
    calc.production.count_workers_s_kpenalty = 0;
    calc.production.s_kbonus = 0;
    calc.production.s_koutput = 0;
    calc.production.s_kpenaly = 0;

    var s_kbonus = 0;
    var s_kpenaly = 0;

    var suhiGroupKBonus = 0;
    var suhiGroupKPenaly = 0;

    var fid = parseInt(calc.calculation.filial_id);
    var additionalSuhiBonusManual = 0;

    //перый проход по работникам, вычисление параметров
    calc.production.workers.forEach(function(w, k){
        if (!((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
            w.personal_init = w.personal;
        } else {
            w.personal_init = w.personal - w.sum_bonus + w.sum_penalty;
        }


        var fi = null;
        for (var i in prodWorkers) {
            var r = prodWorkers[i];
            if (w.worker_id==r.id) {
                fi = r;
                break;
            }
        }

        if (fi)  {
            if (!((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
                 fi.personal_amount_calc = fi.personal_amount_calc;
            } else {
                fi.personal_amount_calc = fi.personal_amount_calc - w.sum_bonus + w.sum_penalty;
            }
        }

   //     console.log(11, fi.personal_amount_calc, w.personal_init);


        if (w.post_code=="driver") return false;
        
        var post = findPostProduction(w.post_code, calc);

        if (!post) {
            if (!w.post_code || w.is_no_post) {
                post = createEmptyPostForNoPostWorker();
                if (!calc.production.posts.find(function(p) { return p.post_code === 'no_post'; })) {
                    calc.production.posts.push(post);
                }
            } else {
                console.log("!!!!!!!", w.post_code)
                return false;
            }
        }

        w.s_bonus_amount = post.s_bonus_amount;
        w.s_personal_amount = post.s_personal_amount;

        //рабочее время
        w.worktime = 0;
        w.intervals.forEach(function(interval){
            if (typeof interval.start=="string") interval.start = moment(interval.start)
            if (typeof interval.finish=="string") interval.finish = moment(interval.finish)

            var diff = interval.finish.diff(interval.start);
            if (diff<0) {
                diff += 60 * 60 * 1000 * 24;
            }
            if (diff>0) w.worktime += diff;
        })
        w.worktime = w.worktime / 1000 / 60 / 60;
        
        if (w.is_no_post || w.post_code === 'no_post') {
            w.sum_salary = 0;
            w.sum_compens = 0;
            w.normday = 0;
            w.worktime_correctly = 0;
            w.worktime_correctly_penalty = 0;
            w.sum_bonus = 0;
            w.sum_penalty = 0;
            w.sum_bonus_calc = 0;
            w.sum_penalty_calc = 0;
            w.sum_surcharge = 0;
            w.sum = 0;
            w.sum_round = 0;
            w.sum_paid = 0;
            w.sum_deposit = 0;
            w.count_products = 0;
            
            post.sum_compens += w.sum_compens;
            post.sum_penalty += w.sum_penalty;
            post.sum_bonus += w.sum_bonus;
            post.sum_salary += w.sum_salary;
            post.count_workers ++;
            calc.production.normday += w.normday;
            calc.production.worktime += w.worktime;
            calc.production.worktime_correctly += w.worktime_correctly;
            calc.production.worktime_correctly_penalty += w.worktime_correctly_penalty;
            calc.production.sum_compens += w.sum_compens;
            calc.production.sum_penalty += w.sum_penalty;
            calc.production.sum_bonus += w.sum_bonus;
            calc.production.sum_salary += w.sum_salary;
            calc.production.count_workers ++;
            
            if (w.post_code) {
                post.sum += w.sum;
                post.sum_round += w.sum_round;
                post.sum_paid += w.sum_paid;
            }
            
            return false;
        }
        
        if (w.worktime<post.s_worktime_compens) {
        } else {
            w.sum_compens = 0;
            w.reason_surcharge_id = null;
        }

        //количество продукта
        if (w.post_code == "pizzamaker") {
            w.count_products = Math.round(post.count_products / 12 * w.worktime);
        }

        if (w.post_code=="pizzamaker" && pizzamaker_non_standart) {
            if (post.count_products<=7) {
                w.sum_salary = 700;
            } else if (post.count_products<=15) {
                w.sum_salary = 1100;
            } else if (post.count_products<=24) {
                w.sum_salary = 1500;
            } else if (post.count_products<=34) {
                w.sum_salary = 1900;
            } else {
                w.sum_salary = 2300;
            }
            additionalSuhi += w.sum_salary;
        } else {
            //зп - оклад
            if (post.type_load=="payday") {
                w.sum_salary = w.s_salary;
            } else {
                w.sum_salary = w.s_salary / 12 * w.worktime;
            }
        }

        if (isProductionRankWithoutFixedSalary(w.category_number)) {
            w.sum_salary = 0;
        }

        //норматив ввыработки в день
        if (w.post_code=="pizzamaker") {
             w.normday = post.s_norm * w.worktime / 12 * w.s_koutput;
        } else if (post.type_load=="payday" || post.type_load=="payhour") {
            w.normday = 0;
        } else {
            w.normday = w.s_koutput * w.worktime * post.s_norm;

        }

        //корректированное врем
        w.worktime_correctly = w.worktime * w.s_kbonus;
        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            s_kbonus += w.s_kbonus;
        }
        if (w.post_code=="STsuhi" || w.post_code=="suhi" || w.post_code=="Suhihot") {
            suhiGroupKBonus += w.s_kbonus;
        }

        w.worktime_correctly_penalty = w.worktime * w.s_kpenaly;
        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            s_kpenaly += w.s_kpenaly;
        }
        if (w.post_code=="STsuhi" || w.post_code=="suhi" || w.post_code=="Suhihot") {
            suhiGroupKPenaly += w.s_kpenaly;
        }

        if (w.post_code!=="pizzamaker") {
            post.normday  += w.normday;
            post.normday_min += w.s_koutput * w.worktime * post.s_proceeds_min;
        } else {
            post.normday += w.normday ;
            post.normday_min = post.s_proceeds_min;
        }

        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            proceeds_office_normday += w.normday;
            proceeds_office_normday_min +=  w.s_koutput * w.worktime * post.s_proceeds_min;
        }
        if (w.post_code=="STsuhi" || w.post_code=="suhi"  || w.post_code=="Suhihot") {
            proceeds_suhi_normday += w.normday;
            proceeds_suhi_normday_min += w.s_koutput * w.worktime * post.s_proceeds_min;
        }
        post.worktime_correctly_penalty += w.worktime_correctly_penalty;
        post.worktime_correctly += w.worktime_correctly;

        if (w.post_code=="pizzamaker" && !w.s_koutput) {
        } else {
            post.worktime += w.worktime;
        }

        //считаем сумму премий за сегодня
        w.sum_bonus = 0;
        w.bonuses.forEach(function(b) {
            w.sum_bonus += b.amount;
            if (w.post_code!="Call-centr") {
                if (!((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
                } else {
                    toPersonalProduction(w.worker_id, b.amount, prodWorkers);
                }
            }
        });

        //считаем сумму штрафов за сегодня
        w.sum_penalty = 0;
        w.fines.forEach(function(b) {
            w.sum_penalty+=b.amount;
            if (w.post_code!="Call-centr") {
                if (!((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
                } else {
                    toPersonalProduction(w.worker_id, -b.amount, prodWorkers);
                }
            }
        });

        if (!((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
            if (w.post_code!="Call-centr") {
                w.personal = w.personal_init;// - w.sum_bonus + w.sum_penalty;
            }
        } else {
            if (w.post_code!="Call-centr") {
                w.personal = w.personal_init + w.sum_bonus - w.sum_penalty;
            }
        }

        if (w.post_code=="pizzamaker" && pizzamaker_non_standart) {
            additionalSuhiBonusManual+= (w.sum_bonus - w.sum_penalty)
        }

        post.sum_compens += w.sum_compens;
        post.sum_penalty += w.sum_penalty;
        post.sum_bonus += w.sum_bonus;
        post.sum_salary += w.sum_salary;
        post.count_workers ++;
        if (w.post_code!=="pizzamaker") {
            calc.production.normday += w.normday;
        }
        calc.production.worktime += w.worktime;
        calc.production.worktime_correctly += w.worktime_correctly;
        calc.production.worktime_correctly_penalty += w.worktime_correctly_penalty;
        calc.production.sum_compens += w.sum_compens;
        calc.production.sum_penalty += w.sum_penalty;
        calc.production.sum_bonus += w.sum_bonus;
        calc.production.sum_salary += w.sum_salary;

        if (w.s_koutput) {
            calc.production.sum_s_koutput += w.s_koutput;
            calc.production.count_workers_s_koutput ++;
        }
        if (w.s_kbonus) {
            calc.production.sum_s_kbonus += w.s_kbonus;
            calc.production.count_workers_s_kbonus ++;
        }
        if (w.s_kpenaly) {
            calc.production.sum_s_kpenalty += w.s_kpenaly;
            calc.production.count_workers_s_kpenalty ++;
        }

        calc.production.count_workers ++;

        //console.log(12, fi.personal_amount_calc, w.personal_init);
    })

    //вычисляем для админов их интервалы рабочие
    var intervals = []; var intervals_sushi = [];
    calc.production.workers.forEach(function(w, k){
        if (w.worktime==0) {
            w.sum_bonus_calc = 0;
        }
        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            if (w.s_koutput>0) {
                w.intervals.forEach(function(i){
                    if (intervals.indexOf(i.start.format("HH:mm"))<0) {
                        intervals.push(i.start.format("HH:mm"));
                    }
                    if (intervals.indexOf(i.finish.format("HH:mm"))<0) {
                        intervals.push(i.finish.format("HH:mm"));
                    }
                })
            }
        }
        if (["suhi", "STsuhi", "Suhihot"].indexOf(w.post_code)>=0) {
            if (w.s_koutput>0) {
                w.intervals.forEach(function(i){
                    if (intervals_sushi.indexOf(i.start.format("HH:mm"))<0) {
                        intervals_sushi.push(i.start.format("HH:mm"));
                    }
                    if (intervals_sushi.indexOf(i.finish.format("HH:mm"))<0) {
                        intervals_sushi.push(i.finish.format("HH:mm"));
                    }
                })
            }
        }
    })

    intervals.sort(); intervals_sushi.sort();

    var prevNormMin = 0;
    var aIntervals = [];
    for (var i=0; i<intervals.length-1; i++) {
        var interval = {start:intervals[i],finish:intervals[i+1], workers:{}, sum:0, norm:0, normMin:prevNormMin, worktime_correctly:0, worktime_correctly_penalty:0, s_kbonus: -1, s_kpenaly: -1, orders:0};
        interval.worktime = moment(interval.finish, "HH:mm").diff(moment(interval.start, "HH:mm"))/1000/60/60;
        calc.production.workers.forEach(function(w, k){
            if (w.worktime==0) return;
            if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
                w.intervals.forEach(function(i){
                    if (i.finish.format("HH:mm")<=interval.start || interval.finish<=i.start.format("HH:mm")) {

                    } else {
                        var post = findPostProduction(w.post_code, calc);
                        var ww = {};
                        w.sum_bonus_calc = 0;
                        w.sum_penalty_calc = 0;
                        w.sum_penalty_calc_not = 0;
                        ww.showname = w.showname;
                        ww.norm = w.s_koutput * interval.worktime * post.s_norm;
                        ww.normMin = w.s_koutput * interval.worktime * post.s_proceeds_min;

                        ww.worktime_correctly = interval.worktime * w.s_kbonus;
                        ww.worktime_correctly_penalty = interval.worktime * w.s_kpenaly;
                        ww.s_penalty = post.s_penalty;

                        if (w.s_kbonus>interval.s_kbonus) {
                            interval.s_kbonus = w.s_kbonus;
                        }

                        if (w.s_kpenaly>interval.s_kpenaly) {
                            interval.s_kpenaly = w.s_kpenaly;
                        }
                        interval.norm += ww.norm;
                        interval.normMin += ww.normMin;
                        interval.worktime_correctly += ww.worktime_correctly;
                        interval.worktime_correctly_penalty += ww.worktime_correctly_penalty;
                        interval.workers[k] = ww;

                    }
                })
            }
        })
        if (typeof calc.production.aorders == "object") {
            for (var t in calc.production.aorders) {
                //interval.orders++;
                var sum = calc.production.aorders[t];
                if (t>interval.start && t<=interval.finish) {
                    interval.sum+=sum;
                    interval.orders+=calc.production.aorders_count[t];
                } else if (i==0 && t<=interval.finish) {
                    interval.sum+=sum;
                    interval.orders+=calc.production.aorders_count[t];
                } else if (i==interval.length-2 && t>interval.start) {
                    interval.sum+=sum;
                    interval.orders+=calc.production.aorders_count[t];
                }
            }
        }
        if (interval.sum<interval.normMin && i<intervals.length-2) {
            prevNormMin=(interval.normMin-interval.sum);
            interval.normMin = interval.sum;
        } else {
            prevNormMin = 0;
        }
        aIntervals.push(interval);
    }


    var sIntervals = [];
    var post = findPostProduction("suhi", calc);
    if (post) {
        var salmon = post.s_salmon * post.salmon;

        for (var i = 0; i < intervals_sushi.length - 1; i++) {
            var interval = {
                start: intervals_sushi[i],
                finish: intervals_sushi[i + 1],
                workers: {},
                sum: 0,
                norm: 0,
                normMin: 0,
                s_kbonus: -1,
                s_kpenaly: -1,
                orders: 0
            };
            interval.worktime = moment(interval.finish, "HH:mm").diff(moment(interval.start, "HH:mm")) / 1000 / 60 / 60;
            calc.production.workers.forEach(function (w, k) {
                if (w.worktime == 0) return;
                if (["suhi", "STsuhi", "Suhihot"].indexOf(w.post_code) >= 0) {
                    w.intervals.forEach(function (i) {
                        if (i.finish.format("HH:mm") <= interval.start || interval.finish <= i.start.format("HH:mm")) {

                        } else {
                            var ww = {};
                            ww.norm = w.s_koutput * interval.worktime * post.s_norm;
                            ww.normMin = w.s_koutput * interval.worktime * post.s_proceeds_min;
                            ww.showname = w.showname;
                            if (w.s_kbonus > interval.s_kbonus) {
                                interval.s_kbonus = w.s_kbonus;
                            }
                            if (w.s_kpenaly > interval.s_kpenaly) {
                                interval.s_kpenaly = w.s_kpenaly;
                            }
//                            console.log(w.post_code, ww.norm, ww.normMin, ww, w);
                            interval.norm += ww.norm;
                            interval.normMin += ww.normMin;
                            interval.workers[k] = ww;
                            //interval.orders = 0;
                        }
                    })
                }
            })
            if (post.aorders && typeof post.aorders == 'object') {
                for (var t in post.aorders) {
                    var sum = post.aorders[t];
                    if (t > interval.start && t <= interval.finish) {
                        interval.orders+=post.aorders_count[t];
                        interval.sum += sum;
                    } else if (i == 0 && t <= interval.finish) {
                        interval.orders+=post.aorders_count[t];
                        interval.sum += sum;
                    } else if (i == intervals_sushi.length - 2 && t > interval.start) {
                        interval.orders+=post.aorders_count[t];
                        interval.sum += sum;
                    }
                }
            }
            sIntervals.push(interval);

        }
    }

    var postA = findPostProduction("administrator", calc);
    var postAOver = postA && postA.s_over ? postA.s_over : 0;
    var postABonus = postA && typeof postA.s_bonus !== 'undefined' ? postA.s_bonus : 0;
    var postAPenalty = postA && typeof postA.s_penalty !== 'undefined' ? postA.s_penalty : 0;
    var pluskiForAdmin = getPluskiDiscountSumForAdmin(calc, res, postA);
    var totalIntervalsSum = 0;
    aIntervals.forEach(function(interval) {
        totalIntervalsSum += interval.sum;
    });
    aIntervals.forEach(function(interval, idx) {
        var intervalSum = interval.sum;
        if (pluskiForAdmin !== 0 && totalIntervalsSum > 0) {
            intervalSum += pluskiForAdmin * (interval.sum / totalIntervalsSum);
        }
        if (postAOver > 0) {
            interval.sum_bonus_calc = ((intervalSum /*+ salmon*/ - interval.norm) / postAOver) * postABonus;
            interval.sum_penalty_calc = ((intervalSum /*+ salmon*/ - interval.normMin) / postAOver) * postAPenalty;
            interval.sum_penalty_calc_report = ((intervalSum /*+ salmon*/ - interval.normMin) / 1100) * 37; //post.s_over * post.s_penalty;
        } else {
            interval.sum_bonus_calc = 0;
            interval.sum_penalty_calc = 0;
            interval.sum_penalty_calc_report = 0;
        }
        if (interval.sum_penalty_calc<0) {
            interval.sum_bonus_calc = 0;
        }
        if (interval.s_kbonus>=0) {
            interval.sum_bonus_calc = interval.sum_bonus_calc * interval.s_kbonus;
        }
        if (interval.s_kpenaly>=0) {
            interval.sum_penalty_calc = interval.sum_penalty_calc * interval.s_kpenaly;
        }
        if (interval.s_kpenaly>=0) {
            interval.sum_penalty_calc_report = interval.sum_penalty_calc_report * interval.s_kpenaly;
        }

        for (var id in interval.workers) {
            var w = interval.workers[id];
            w.sum_bonus_calc = (interval.sum_bonus_calc / interval.worktime_correctly) * w.worktime_correctly;
            w.sum_penalty_calc = (interval.sum_penalty_calc / interval.worktime_correctly_penalty) * w.worktime_correctly_penalty/* * w.s_penalty*/;
            w.sum_penalty_calc_report = (interval.sum_penalty_calc_report / interval.worktime_correctly_penalty) * w.worktime_correctly_penalty/* * w.s_penalty*/;
            calc.production.workers[id].sum_bonus_calc+= w.sum_bonus_calc > 0 ? w.sum_bonus_calc : 0;
            calc.production.workers[id].sum_penalty_calc+= w.sum_penalty_calc < 0 ? w.sum_penalty_calc : 0;
            calc.production.workers[id].sum_penalty_calc_not+= w.sum_penalty_calc_report < 0 ? w.sum_penalty_calc_report : 0;
        }
    })

    var sBonusSuhi = 0, sPenaltySuhi=0;
    sIntervals.forEach(function(interval, i) {
        var s = 0;
        if (i==sIntervals.length-1) s = salmon;

        interval.sum_bonus_calc = (interval.sum + s - interval.norm ) / post.s_over * post.s_bonus;
        interval.sum_penalty_calc = (interval.sum /*+ salmon*/ - interval.normMin ) / post.s_over * post.s_bonus;

        if (interval.s_kbonus>=0) {
            interval.sum_bonus_calc = interval.sum_bonus_calc * interval.s_kbonus;
        }
        if (interval.s_kpenaly>=0) {
            interval.sum_penalty_calc = interval.sum_penalty_calc * interval.s_kpenaly;
        }

       sBonusSuhi+=interval.sum_bonus_calc ; sPenaltySuhi+=interval.sum_penalty_calc;
    })

    console.log("suhi", sIntervals);
    console.log("adm", aIntervals);
    res.sIntervals = sIntervals;
    res.aIntervals = aIntervals;

    //отдельно проходим по пиццамейкерам и считаем их выработку
     calc.production.workers.forEach(function(w, k){
        if (w.post_code == "pizzamaker") {
            var post = findPostProduction(w.post_code, calc);
            if (!w.s_koutput) {
                w.count_products = 0;
            } else if (post.worktime>0) {
                w.count_products = Math.round(post.count_products / post.worktime * w.worktime * 10)/10;
            }
        }
    })

    if (calc.production.count_workers_s_kbonus)
        calc.production.s_kbonus = calc.production.sum_s_kbonus / calc.production.count_workers_s_kbonus;

    if (calc.production.count_workers_s_koutput)
        calc.production.s_koutput = calc.production.sum_s_koutput / calc.production.count_workers_s_koutput;

    var additionalSuhiBonus=0;
    if (pizzamaker_non_standart) {
        var post = findPostProduction("pizzamaker", calc); var posts = findPostProduction("suhi", calc);
        if (post && posts) {
            calc.production.workers.forEach(function(w, k){
                if (w.post_code=="pizzamaker") {
                    var sum_bonus_calc = (w.count_products -w.normday) / post.s_over * post.s_bonus;
                    if (sum_bonus_calc<0) sum_bonus_calc = 0;
                    if (post.s_bonus_max && sum_bonus_calc>post.s_bonus_max) sum_bonus_calc = post.s_bonus_max;
                    additionalSuhiBonus+=sum_bonus_calc;
                }
            })
        }
    }

    if (sBonusSuhi<0) sBonusSuhi=0;

    //проход по должностям, вычисление общих параметров
    calc.production.posts.forEach(function(post, k){
        if (post.post_code!="driver") {
            if (post.s_over>0) {
                var salmon = post.s_salmon * post.salmon;
                if (post.type_load=="payhour" || post.type_load=="payday") {
                    post.sum_bonus_calc = 0;
                    post.sum_penalty_calc = 0;
                } else if ((post.type_load=="proceeds_office" || post.type_load=="proceeds_order_type") && (isAdmin(post.post_code) || post.post_code == "franchise administrator")) {
                    post.sum_bonus_calc = 0;
                    post.sum_penalty_calc = 0;
                    post.sum_penalty_calc_report = 0;
                } else if (post.type_load=="proceeds_office") {
                    var postRevenuePlusBonuses = post.crm_sum + salmon;
                    if ("pluski_discount_sum" in post) {
                        postRevenuePlusBonuses += (post.pluski_discount_sum || 0);
                    }
                    post.sum_bonus_calc = (postRevenuePlusBonuses - post.normday ) / post.s_over * post.s_bonus;
                    post.sum_penalty_calc = (postRevenuePlusBonuses - post.normday_min ) / post.s_over * post.s_penalty;
                } else {
                    var postRevenuePlusBonuses = post.crm_sum + salmon;
                    if ("pluski_discount_sum" in post) {
                        postRevenuePlusBonuses += (post.pluski_discount_sum || 0);
                    }
                    post.sum_bonus_calc = (postRevenuePlusBonuses - post.normday ) / post.s_over * post.s_bonus;
                    post.sum_penalty_calc = (postRevenuePlusBonuses - post.normday_min ) / post.s_over * post.s_penalty;
                    if (post.post_code=="suhi" || post.post_code=="STsuhi" || post.post_code=="Suhihot") {
                        var postS = findPostProduction("suhi", calc);
                        if (postS) {
                            salmon = postS.s_salmon * postS.salmon;
                        }
                        var suhiRevenuePlusBonuses = (postS ? postS.crm_sum : post.crm_sum) + salmon;
                        var suhiPost = postS || post;
                        if (suhiPost && "pluski_discount_sum" in suhiPost) {
                            suhiRevenuePlusBonuses += (suhiPost.pluski_discount_sum || 0);
                        }
                        post.sum_penalty_calc = (suhiRevenuePlusBonuses - proceeds_suhi_normday_min) / post.s_over * post.s_penalty;
                    }
                    if (post.post_code=="suhi") {
                        post.sum_bonus_calc=sBonusSuhi;
                    }
                }

                if (post.sum_bonus_calc < 0) post.sum_bonus_calc = 0;
                if (post.sum_penalty_calc > 0 ) post.sum_penalty_calc = 0;
                post.sum_penalty_calc = -post.sum_penalty_calc;
                if (smena==2) {
                    post.sum_penalty_calc = 0;
                }

                if (post.post_code=="suhi" && pizzamaker_non_standart) {
                    post.sum_bonus_calc+=additionalSuhi;
                    post.sum_bonus_calc+=additionalSuhiBonus;
                    post.sum_bonus_calc+=additionalSuhiBonusManual;
                }

                if (calc.calculation.filialID!=16 && calc.calculation.filialID!=34  && calc.calculation.filialID!=31  && calc.calculation.filialID!=33) {
                    if (post.post_surcharge) post.sum_bonus_calc+=post.post_surcharge;
                    if (post.post_code=="suhi" && "promo_rolls" in post && isNumber(post.promo_rolls))  {
                        post.sum_bonus_calc+=30*post.promo_rolls;
                        console.log("rolls", post.promo_rolls);
                    }
                    if (post.post_code=="suhi" && "promo_lunch" in post && isNumber(post.promo_lunch))  {
                        post.sum_bonus_calc+=37*post.promo_lunch;
                        console.log("lunch", post.promo_lunch);
                    }
                    if (post.post_code=="suhi" && "promo_soups" in post && isNumber(post.promo_soups))  {
                        post.sum_bonus_calc+=25*post.promo_soups;
                        console.log("soupts", post.promo_soups);
                    }
                    if (post.post_code=="suhi" && "promo_hot" in post && isNumber(post.promo_hot))  {
                        post.sum_bonus_calc+=25*post.promo_hot;
                        console.log("hot", post.promo_hot);
                    }
                    if (post.post_code=="suhi" && "promo_pizza" in post && isNumber(post.promo_pizza))  {
                        post.sum_bonus_calc+=40*post.promo_pizza;
                        console.log("пицца", post.promo_pizza);
                    }
                }


                if (post.worktime_correctly > 0) {
                    if (post.worktime_correctly<12) {
                        post.bonus_hour = post.sum_bonus_calc / 12; //рассчетная, не нужна в стате
                    } else {
                        post.bonus_hour = post.sum_bonus_calc / post.worktime_correctly; //рассчетная, не нужна в стате
                    }
                }   else {
                    post.bonus_hour = 0;
                }

                if (post.post_code=='administrator' && post.worktime>12) {
                    post.bonus_hour = post.sum_bonus_calc/post.worktime;

                }
                if (post.worktime_correctly_penalty > 0) {
                    post.penalty_hour = post.sum_penalty_calc / post.worktime_correctly_penalty;
                }   else {
                    post.penalty_hour = 0;
                }

            } else {
                post.sum_bonus_calc = 0;
                post.sum_penalty_calc = 0;
            }
        }
    })

    var fid = parseInt(calc.calculation.filial_id);

    var post = findPostProduction("suhi", calc);
    sBonusSuhi=sBonusSuhi+additionalSuhi+additionalSuhiBonusManual+additionalSuhiBonus;
    var worktimeCorrectlySuhi=0, worktimeCorrectlySuhiP=0;
    if (post) {
        worktimeCorrectlySuhi += post.worktime_correctly;
        worktimeCorrectlySuhiP += post.worktime_correctly_penalty;
    }
    if (post && calc.calculation.filialID!=16 && calc.calculation.filialID!=34  && calc.calculation.filialID!=31  && calc.calculation.filialID!=33) {
        if ("promo_rolls" in post && isNumber(post.promo_rolls))  {
            sBonusSuhi+=30*post.promo_rolls;
        }
        if (post.post_code=="suhi" && "promo_lunch" in post && isNumber(post.promo_lunch))  {
            sBonusSuhi+=37*post.promo_lunch;
        }
        if (post.post_code=="suhi" && "promo_soups" in post && isNumber(post.promo_soups))  {
            sBonusSuhi+=25*post.promo_soups;
        }
        if (post.post_code=="suhi" && "promo_hot" in post && isNumber(post.promo_hot))  {
            sBonusSuhi+=25*post.promo_hot;
        }
        if (post.post_code=="suhi" && "promo_pizza" in post && isNumber(post.promo_pizza))  {
            sBonusSuhi+=40*post.promo_pizza;
        }
    }
    var postS = findPostProduction("STsuhi", calc);
    if (postS) {
        worktimeCorrectlySuhi += postS.worktime_correctly;
        worktimeCorrectlySuhiP += postS.worktime_correctly_penalty;
    }
    var postS2 = findPostProduction("Suhihot", calc);
    if (postS2) {
        worktimeCorrectlySuhi += postS2.worktime_correctly;
        worktimeCorrectlySuhiP += postS2.worktime_correctly_penalty;
    }

    if (worktimeCorrectlySuhi>0) {
        if (worktimeCorrectlySuhi<12) {
            if (post) post.bonus_hour = sBonusSuhi / 12; //рассчетная, не нужна в стате
            if (postS) postS.bonus_hour = sBonusSuhi / 12; //рассчетная, не нужна в стате
            if (postS2) postS2.bonus_hour = sBonusSuhi / 12; //рассчетная, не нужна в стате
        } else {
            if (post)  post.bonus_hour = sBonusSuhi / worktimeCorrectlySuhi; //рассчетная, не нужна в стате
            if (postS)  postS.bonus_hour = sBonusSuhi / worktimeCorrectlySuhi; //рассчетная, не нужна в стате
            if (postS2)  postS2.bonus_hour = sBonusSuhi / worktimeCorrectlySuhi; //рассчетная, не нужна в стате
        }
    }
    if (worktimeCorrectlySuhiP > 0) {
        if (post) post.penalty_hour = post.sum_penalty_calc / worktimeCorrectlySuhiP;
        if (postS) postS.penalty_hour = postS.sum_penalty_calc / worktimeCorrectlySuhiP;
        if (postS2) postS2.penalty_hour = postS2.sum_penalty_calc / worktimeCorrectlySuhiP;
    }

    //проход по должностям, вычисление общих параметров
    calc.production.posts.forEach(function(post, k){
        if (post.post_code!="driver") {
            post.sum_bonus_calc = 0;
            post.sum_penalty_calc = 0;
            post.sum_paid = 0;
        }
    })

    //второй проход, вычисление бонусов и штрафов
    calc.production.workers.forEach(function(w, k){
        if (w.post_code=="driver") return false;
        var post = findPostProduction(w.post_code, calc);

        if (!post) return false;

        //вычисляемый бонус
        if ((post.type_load=="proceeds_office" || post.type_load=="proceeds_order_type" || post.type_load=="orders_order_type") && (isAdmin(post.post_code) || post.post_code == "franchise administrator")) {
        } else {
            w.sum_bonus_calc = 0;
            w.sum_penalty_calc = 0;
        }

        var fid = parseInt(calc.calculation.filial_id);

        if (post.type_load=='proceeds_percent') {
            var bpercent =-1;

            if ('s_bonus' in post && post.s_bonus ) {
                var bp = parseFloat(post.s_bonus);
                if (!isNaN(bp)) bpercent = bp;
            }
            if ('s_bpercent' in w) {
                var bp = parseFloat(w.s_bpercent);
                if (!isNaN(bp)) bpercent = bp;
            }
            if (calc.calculation && calc.calculation.filial_id==18 && calc.calculation.date=='24.11.2022') {
                bpercent = 0.5;
            }
            if (bpercent!=-1) {
                var revenuePlusBonuses = post.crm_sum || 0;
                var pluskiValue = getPluskiDiscountSumForAdmin(calc, res, post);
                revenuePlusBonuses += pluskiValue;
                w.sum_bonus_calc = revenuePlusBonuses * bpercent / 100;
            }
            console.log("4535", post.crm_sum, bpercent, w.sum_bonus_calc, w.s_bpercent, post.s_bonus);
        } else if (post.type_load=="products_employee" || post.type_load=="proceeds_employee" || post.type_load=="orders_employee") {
            if (post.s_over!=0) {
                var workerRevenuePlusBonuses = w.count_products || 0;
                if (post.type_load=="proceeds_employee" && post.post_code && (post.post_code.indexOf("administrator") !== -1 || post.post_code === "admin_smeny")) {
                    var workerPost = findPostProduction(w.post_code, calc);
                    var workerPluskiDiscountSum = getPluskiDiscountSumForAdmin(calc, res, workerPost);
                    if (workerPluskiDiscountSum !== 0) {
                        var pluskiPerWorker = workerPluskiDiscountSum / Math.max(1, calc.production.workers.filter(function(w2) { return w2.post_code === w.post_code; }).length);
                        workerRevenuePlusBonuses += pluskiPerWorker;
                    }
                }
                w.sum_bonus_calc = (workerRevenuePlusBonuses - w.normday) / post.s_over * post.s_bonus;
                w.sum_penalty_calc = (workerRevenuePlusBonuses - post.normday_min ) / post.s_over * post.s_penalty;
            }
            if (w.sum_bonus_calc < 0) w.sum_bonus_calc = 0;
            if (w.sum_penalty_calc > 0 ) w.sum_penalty_calc = 0;
            w.sum_penalty_calc = -w.sum_penalty_calc;
            if (!(post.s_penalty_max === null)  && w.sum_penalty_calc>post.s_penalty_max) w.sum_penalty_calc = post.s_penalty_max;
            if (!(post.s_bonus_max === null)  && w.sum_bonus_calc>post.s_bonus_max) w.sum_bonus_calc = post.s_bonus_max;


        } else if (post.type_load=="payday" || post.type_load=="payhour") {

        } else if ((post.type_load=="proceeds_office" || post.type_load=="proceeds_order_type" ||   post.type_load=="orders_order_type")  && (isAdmin(post.post_code) || post.post_code == "franchise administrator")) {
            if (w.sum_bonus_calc < 0) w.sum_bonus_calc = 0;
            if (w.sum_penalty_calc > 0 ) w.sum_penalty_calc = 0;
            if (w.sum_penalty_calc_not > 0 ) w.sum_penalty_calc_not = 0;

            if (w.sum_penalty_calc<0 && w.sum_bonus_calc>0) {
                var s = w.sum_penalty_calc + w.sum_bonus_calc;
                if (s>0) {
                    w.sum_penalty_calc = 0;
                    w.sum_bonus_calc = s;
                } else {
                    w.sum_penalty_calc = s;
                    w.sum_bonus_calc = 0;
                }
            }

            if (w.sum_penalty_calc_not<0 && w.sum_bonus_calc>0) {
                var s = w.sum_penalty_calc_not + w.sum_bonus_calc;
                if (s>0) {
                    w.sum_penalty_calc_not = 0;
                } else {
                    w.sum_penalty_calc_not = s;
                }
            }
            w.sum_penalty_calc = -w.sum_penalty_calc;
            w.sum_penalty_calc_not = -w.sum_penalty_calc_not;
            if (post.s_bonus_max && w.sum_bonus_calc>post.s_bonus_max)  w.sum_bonus_calc = post.s_bonus_max;
            if (w.sum_penalty_calc>post.s_penalty_max) w.sum_penalty_calc = post.s_penalty_max;


        } else if (w.post_code!=="pizzamaker" && ! (typeof post.bonus_hour == 'undefined')) {
            var b = post.bonus_hour * w.worktime_correctly;
            if (post.s_bonus_max && b>post.s_bonus_max)  b = post.s_bonus_max;
            w.sum_bonus_calc = b;
            var s = w.worktime_correctly_penalty>0 ? post.penalty_hour * w.worktime_correctly_penalty : 0;
            if (w.post_code=="administrator") {
                w.sum_penalty_calc_not = s;
            }
            if (s>post.s_penalty_max) s = post.s_penalty_max;
            w.sum_penalty_calc =   s;

        } else if (post.s_over > 0) { //pizzamaker
            w.sum_bonus_calc = (w.count_products -w.normday) //fixme
                / post.s_over
                * post.s_bonus;
            if (w.sum_bonus_calc<0) w.sum_bonus_calc = 0;
            if (post.s_bonus_max && w.sum_bonus_calc>post.s_bonus_max) w.sum_bonus_calc = post.s_bonus_max;
        }

        if (isProductionRankWithoutExceedingPremiumBonus(w.category_number)) {
            w.sum_bonus_calc = 0;
        }

        post.sum_bonus_calc += w.sum_bonus_calc;
        post.sum_penalty_calc += w.sum_penalty_calc;
        calc.production.sum_bonus_calc += w.sum_bonus_calc;
        calc.production.sum_penalty_calc += w.sum_penalty_calc;

        //если соотвествующая настройка должности
        if (post.s_bonus_amount) {
            toPersonalProduction(w.worker_id, w.sum_bonus_calc, prodWorkers);
        }

        if (w.select_id in prodWorkers) {
            var ww = prodWorkers[w.select_id];

        }

        var sum =  w.sum_salary;
        w.sum_surcharge = 0;

        var surcharge_percent = 0, surcharge_fix = 0;
        if ("surcharges" in post && Array.isArray(post.surcharges) && post.surcharges.length>0) {
            post.surcharges.forEach(function(s){
                var added=false;

                if ("workers_exclude" in s && Array.isArray(s.workers_exclude)) {
                    if(s.workers_exclude.indexOf(w.worker_id)>=0 || s.workers_exclude.indexOf(w.worker_id.toString())>=0) {
                        return ;
                    }
                    var tb = s["timebeg"];
                    var te = s["timeend"];
                    tb = "0 " + tb;
                    if (te<"10") te = "1 " + te;
                    else te = "0 " + te;

                    var sf =0; sp = 0;
                    w.intervals.forEach(function(i) {
                        if (added) return;
                        var wtb = i.start.format("HH:mm").toString();
                        var wte = i.finish.format("HH:mm").toString();
                        wtb = "0 " + wtb;
                        if (wte<"10") wte = "1 " + wte;
                        else wte = "0 " + wte;


                        if ((wtb==tb && wte==te) || (wtb>te && wtb<te) || (wte>tb && wte<te)) {
                            surcharge_percent += s.percent;
                            surcharge_fix += s.fix;
                            added = true;
                        }
                    })
                }
            })
        }

        w.sum_surcharge += sum / 100 * surcharge_percent;
        w.sum_surcharge += surcharge_fix;

        if (smena==2) {
            w.sum_penalty_calc = 0;
        }

        w.sum = sum
            + w.sum_surcharge
            + w.sum_bonus
            + w.sum_bonus_calc
            + w.sum_compens
            - w.sum_penalty
            - w.sum_penalty_calc;

        w.sum_paid = sum
            + w.sum_surcharge
            + w.sum_compens;
            //+ w.personal;

        if ( !((fid==25 && !isAdmin(w.post_code)) || fid==28 || fid==16)) {
                w.sum_paid+=w.sum_bonus;
                w.sum_paid-=w.sum_penalty;

        } else {
            if (w.post_code=="Call-centr") {
                w.sum_paid+=w.sum_bonus;
                w.sum_paid-=w.sum_penalty;
            }
        }


        if (!post.s_bonus_amount) {
            w.sum_paid += w.sum_bonus_calc;
        }

        w.sum_paid -= w.sum_penalty_calc;
        if (post.post_code=="pizzamaker" && pizzamaker_non_standart) {
            w.sum_paid=0;
        }

        if (post.post_code=="pizzamaker" && pizzamaker_non_standart) {
        } else {
            calc.production.sum += w.sum;
        }
        calc.production.sum_paid += w.sum_paid;

        //вычитание депозита
        w.sum_deposit = 0;
        if ("s_dep_handmode" in post && !post.s_dep_handmode && w.deposit<w.deposit_norm) {
            if (!post.s_dep_shift_count || (w.smenas && w.smenas>post.s_dep_shift_count)) {
                if (!post.s_dep_min_salary || w.sum>=post.s_dep_min_salary) {
                    var checkCategory = true;
                    if (post.s_dep_rank) {
                        checkCategory = false;
                        if (post.post_code in settingsProduction) {
                            var sp = settingsProduction[post.post_code].categories;
                            if (post.s_dep_rank in sp) {
                                sp = sp[post.s_dep_rank];
                                if (sp.number<=w.category_number) {
                                    checkCategory = true;
                                }
                            }
                        }
                    }

                    if (checkCategory) {
                        var checkFilial = true;
                        if (post.s_dep_filial_attached) {
                            checkFilial = false;
                            if (w.select_id in prodWorkers) {
                                var wp = prodWorkers[w.select_id];
                                var fid = parseInt(calc.calculation.filialID);
                                if (wp.filial_id=fid) {
                                    checkFilial = true;
                                }
                            }
                        }

                        if (checkFilial) {
                            if (post.s_dep_payment_typed == "rub") {
                                w.sum_deposit = post.s_dep_shift_payment;
                            } else {
                                w.sum_deposit = Math.round(w.sum / 100 * post.s_dep_shift_payment);
                            }
                        }
                    }
                }
            }
        }
        if (w.deposit_norm-w.deposit<w.sum_deposit) {
            w.sum_deposit = w.deposit_norm-w.deposit;
        }

        if (w.sum_deposit<0) {
            w.sum_deposit = 0;
        }

        w.sum_round = Math.round(w.sum/totalSettings.rounding_zp)*totalSettings.rounding_zp;
        w.sum_paid = w.sum_paid - w.sum_deposit
        w.sum_paid = Math.round(w.sum_paid/totalSettings.rounding_zp)*totalSettings.rounding_zp;

        var personal = 0;
        if (!(fid==25 || fid==28 || fid==16) ||  "s_personal_amount" in post && post.s_personal_amount && !w.changedPersonal) {
            personal = -w.sum_paid +  w.sum_bonus - w.sum_penalty;
            if (w.personal_history.length==0) {
                w.personal_history.push({
                      type: personal < 0 ? "+" : "-",
                      amount: Math.abs(Math.round(personal)),
                      authorName: "",
                      comment: 'начислено при расчете ЗП',
                      reason: null,
                      reason_id: res.reasonAccrualIdDefault,
                })
            }
            w.personal_history[0].type = personal < 0 ? "+" : "-";
            w.personal_history[0].amount = Math.abs(Math.round(personal));
            w.sum_paid = 0;
        }
        w.personal = 0;
        w.personal_history.forEach((p)=>{
           w.personal += p.type=="+" ?  -p.amount : p.amount;
        });
        toPersonalProduction(w.worker_id, w.personal-w.personal_init, prodWorkers);

        w.sum_paid = w.sum_paid+w.personal-personal;
        post.sum += w.sum;
        post.sum_round += w.sum_round;
        post.sum_paid += w.sum_paid;
    })

    /*
    calc.production.workers.sort(function(w, w1){
        var s1 = w.position + "#" +  w.showpost  + "#" + w.showname + "#" + w.worker_id;
        var s2 = w1.position + "#" +  w1.showpost  + "#" + w1.showname+ "#" + w.worker_id;
        if (s1>s2) return 1;
        return -1;
    })
     */



    calc.production.proceeds_office_normday = proceeds_office_normday;
    calc.production.proceeds_office_normday_min = proceeds_office_normday_min;
    //totalView.recalcTable();
    //delayedView.recalcTable();
    return res;
}

export function initFromCRM(res, now) {
	res = recalcTotalProduction(res, null, null, now)
	res = recalcTotalDrivers(res,  now)
	res = initDelayedFromCrm(res)
	return res
}

const settingsPostMappingDrivers = {'price_time':'ptime', 'price_distance':'pdistance', 'price_orders':"porder", 'price_departure':'pdeparture', 'arr_result':'result', 's_bonus_amount':'bonus_amount', 's_personal_amount':'personal_amount',
    's_typepdepature': "typepdepature", "s_typetimework" : "typetimework", "arr_departure":"mileage_result"};

function recalcPostsDrivers(result){
    let calc = result.calc
    let settingsProduction = result.settings.production
    let surcharges = result.surcharges

    calc.drivers.posts = [];
    var t = this;
    for (var k in settingsProduction) {
        var p = settingsProduction[k];
        if (p.type=="driver") {
            var post = {
                price_time: 0,
                price_orders: 0,
                price_distance: 0,
                price_departure: 0,
                arr_result: 0,
                arr_departure : 0
            }

            if (k in surcharges && Array.isArray(surcharges[k])) {
                surcharges[k].forEach(function(s, i){
                    if ("fix" in surcharges[k][i]) {
                        var s = parseFloat(surcharges[k][i].fix);
                        surcharges[k][i].fix = s;
                    }
                    if ("percent" in surcharges[k][i]) {
                        var s = parseFloat(surcharges[k][i].percent);
                        surcharges[k][i].percent = s;
                    }

                })
                post.surcharges = surcharges[k];
            }
            post.route_type = "route_type" in p && p.route_type ? p.route_type : "car";
            post.name = p.name;
            post.post_code = p.code;
            var s = p.s || {};
            for (var n2 in settingsPostMappingDrivers) {
                var n1 = settingsPostMappingDrivers[n2];
                if (n2=="s_typepdepature") post[n2] =  "fix";
                else if (n2=="s_typetimework") post[n2] = "percent";
                else  post[n2] = 0;
                if (n1 in s) {
                    var v = parseFloat(s[n1]);

                    if(n1 == 'result' || n1=="typepdepature" || n1=="typetimework"){
                        v = s[n1];
                    }
                    if (!isNaN(v)) {
                        post[n2] = v;
                    }
                }
            };
            calc.drivers.posts.push(post);
        }
    }
}
var savedPostsDrivers = {};

function showDrivers(result) {
    let calc = result.calc
    let drivers = result.drivers
    calc.drivers.crm_sum = 0;
    calc.drivers.workers.forEach(function(w){
        var driver;
        for (var i in drivers) {
            var d = drivers[i]
            if (d.id==w.worker_id) {
                driver = d;
                break;
            }
        }
        if (driver) {
            driver.deposit -= w.sum_deposit;
        }
        if ("orders_sum" in w) {
            calc.drivers.crm_sum += w.orders_sum;
        }
        if (!w.post_code && driver) {
            w.post_code = driver.post_code;
        }
        w.posts = driver && driver.posts ? driver.posts : [];
    })
    recalcPostsDrivers(result);
    calc.drivers.workers.forEach(function(d) {
        savedPostsDrivers[d.worker_id] = d.post_code;
    })
}
export function getProductionProceedsOfficeNormday(calc) {
    let proceeds_office_normday = 0;
    calc.production.workers.forEach(function (w, k) {
        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            proceeds_office_normday += w.normday;
        }
    })
    return proceeds_office_normday;
}

function showProduction(result) {
    let calc = result.calc;
    let settingsProduction = result.settings.production
    let prodWorkers = result.production

    var ssp = {
        s_dep_shift_payment : "shift_payment",
        s_dep_min_salary : "dep_min_salary",
        s_dep_shift_count : "shift_count",
        s_dep_rank : "rank",
        s_dep_filial_attached : "filial_attached",
        s_dep_handmode : "deposit_handmode",
        s_dep_payment_typed : "shift_payment_type",
    };

    calc.production.posts.forEach(function(p){
        if (p.post_code in settingsProduction) {
            var s = settingsProduction[p.post_code].s;
            for (var n2 in ssp) {
                var n1 = ssp[n2];
                p[n2] = 0;
                if (n1 in s) {
                    if (n1=="shift_payment_type") {
                        p[n2] = s[n1];
                    } else if (n1=="norm_up") {
                        p[n2] = s[n1];
                    } else {
                        var v = parseFloat(s[n1]);
                        if (!isNaN(v)) p[n2] = v;
                        else if (n1=="s_penalty_max" || n2=="s_bonus_max") {
                            p[n2] = null;
                        }
                    }
                }
            }
            p.position = settingsProduction[p.post_code].position;

            p["type_load_is_system"] = 1;
            if ("type_load_is_system" in s) {
                p["type_load_is_system"] = s["type_load_is_system"];
            }

        }

        p.promo_rolls = 0;
        if (p.post_code=="suhi") {
            if ("promo_rolls" in calc.production && isNumber(calc.production.promo_rolls)) {
                p.promo_rolls = calc.production.promo_rolls;
            }
        }

        p.promo_lunch = 0;
        if (p.post_code=="suhi") {
            if ("promo_lunch" in calc.production && isNumber(calc.production.promo_lunch)) {
                p.promo_lunch = calc.production.promo_lunch;
            }
        }

        p.promo_soups = 0;
        if (p.post_code=="suhi") {
            if ("promo_soups" in calc.production && isNumber(calc.production.promo_soups)) {
                p.promo_soups = calc.production.promo_soups;
            }
        }
        p.promo_hot = 0;
        if (p.post_code=="suhi") {
            if ("promo_hot" in calc.production && isNumber(calc.production.promo_hot)) {
                p.promo_hot = calc.production.promo_hot;
            }
        }
        p.normday_min = 0;
        p.count_workers = 0;
    })
    var proceeds_office_normday = 0;
    var proceeds_office_normday_min = 0;

    calc.production.bonus_id = 0;
    calc.production.fine_id = 0;
    calc.production.author_bonus =  0;
    calc.production.author_fine =  0;
    calc.production.count_workers = 0;
    calc.production.sum_s_koutput = 0;
    calc.production.sum_s_kbonus = 0;
    calc.production.sum_s_kpenalty = 0;
    calc.production.count_workers_s_koutput = 0;
    calc.production.count_workers_s_kbonus = 0;
    calc.production.count_workers_s_kpenalty = 0;
    calc.production.s_kbonus = 0;
    calc.production.s_kpenaly = 0;
    calc.production.s_koutput = 0;

    //перый проход по работникам, вычисление параметров
    calc.production.workers.forEach(function(w, k){
        if (w.post_code in settingsProduction) {
            var sp = settingsProduction[w.post_code];
            if (w.category_id in sp.categories) {
                var sc = sp.categories[w.category_id];
                _initCategorySettingProduction(w, sc);
            }
        }


        if (w.post_code=="driver") return false;
        var post = findPostProduction(w.post_code, calc);
        if (!post && (w.is_no_post || w.post_code === 'no_post')) {
            post = createEmptyPostForNoPostWorker();
            if (!calc.production.posts.find(function(p) { return p.post_code === 'no_post'; })) {
                calc.production.posts.push(post);
            }
        }
        if (!post) return false;
        var worker = null;
        for (var wk in prodWorkers){
            var ww = prodWorkers[wk];
            if (ww.id == w.worker_id)  {
                worker = ww;
                break;
            }
        }
        if (worker) {
            if (!("personal_amount_calc" in worker)) {
                worker.personal_amount_calc =  worker.personal_amount;
            }
            if (w.sum_paid!=0) {
                w.changedPersonal = true;
            }
            w.deposit_norm = parseFloat(worker.deposit_norm);
            if (isNaN(w.deposit_norm)) w.deposit_norm = 0;
            w.deposit = parseFloat(worker.deposit);
            if (isNaN(w.deposit)) w.deposit = 0;

            if ("sum_deposit" in w && isNumber(w.sum_deposit) && "sum_deposit" in w) {
                w.deposit = w.deposit - w.sum_deposit;
            }
            if (w.deposit<0) {
                w.deposit = 0;
            }
            //console.log(w.sum_deposit)

            w.smenas = parseInt(worker.smenas);
            if (isNaN(w.smenas)) w.smenas = 0;

            if (!("bonus_amount_calc" in worker)) {
                worker.bonus_amount = 0;
                worker.bonus_amount_calc =  worker.bonus_amount;
            }
            if (post && "s_bonus_amount" in post && post.s_bonus_amount) {
                if (w.personal!=w.sum_bonus-w.sum_penalty) {
                    w.changedPersonal = true;
                }
            }
        }

        if (w.post_code!=="pizzamaker") {
            post.normday_min += w.s_koutput * w.worktime * post.s_proceeds_min;
        } else {
            post.normday_min = post.s_proceeds_min;
        }

//            if (post.type_load=="proceeds_office") {
        if (isAdmin(w.post_code) || w.post_code == "franchise administrator") {
            proceeds_office_normday += w.normday;
            proceeds_office_normday_min +=  w.s_koutput * w.worktime * post.s_proceeds_min;
        }

        post.count_workers ++;

        if (w.s_koutput) {
            calc.production.sum_s_koutput += w.s_koutput;
            calc.production.count_workers_s_koutput ++;
        }

        if (w.s_kbonus) {
            calc.production.sum_s_kbonus += w.s_kbonus;
            calc.production.count_workers_s_kbonus ++;
        }

        if (w.s_kpenaly) {
            calc.production.sum_s_kpenalty += w.s_kpenaly;
            calc.production.count_workers_s_kpenalty ++;
        }

        calc.production.count_workers ++;
    })

    if (calc.production.count_workers_s_kbonus)
        calc.production.s_kbonus = calc.production.sum_s_kbonus / calc.production.count_workers_s_kbonus;

    if (calc.production.count_workers_s_kpenalty)
        calc.production.s_kpenaly = calc.production.sum_s_kpenalty / calc.production.count_workers_s_kpenalty;

    if (calc.production.count_workers_s_koutput)
        calc.production.s_koutput = calc.production.sum_s_koutput / calc.production.count_workers_s_koutput;

    calc.production.proceeds_office_normday = proceeds_office_normday;
    calc.production.proceeds_office_normday_min = proceeds_office_normday_min;

    //    totalView.recalcTable();
      //  delayedView.recalcTable();

}


export function initSaved(result) {
    let calc = result.calc
    let totalSettings = result.total_settings
    let rounding_zp = totalSettings.rounding_zp;
    let drivers = result.drivers
    calc.drivers.workers.forEach(function(w){
        w.intervals.forEach(function(i) {
            var d = moment(i.start, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            i.start =  moment(d, "HH:mm");
            d = moment(i.finish, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            i.finish = moment(d, "HH:mm");
        })
        if (w.worker_id in drivers) {
            w.doc_problem = drivers[w.worker_id].doc_problem;
            w.fired = drivers[w.worker_id].fired;
            w.personal_amount = drivers[w.worker_id].personal_amount;
            w.bonus_amount = drivers[w.worker_id].bonus_amount;
            w.personal_amount_calc = w.personal_amount;
            w.bonus_amount_calc =  w.bonus_amount;
        }
    })

    calc.production.workers.forEach(function(w){
        w.select_id = w.worker_id + "-" + w.post_code;
        w.intervals.forEach(function(i) {
            var d = moment(i.start, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            i.start =  moment(d, "HH:mm");
            d = moment(i.finish, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
            i.finish = moment(d, "HH:mm");
        })
    })

    showDrivers(result)
    showProduction(result)
    initSurchargesProduction(calc, result.surcharges)


    //productionView.checkNewPosts(); //с момента рассчета могли появиться новые должности, их нужно учитывать
    //productionView.show($reInitSelect);
    //productionView.initSurcharges();

    //driversView.show();
    //delayedView.show();

    calc.calculation.filialID = calc.calculation.filial_id;
}

